<template>
  <div class="info-container">
    <!-- 拼连接 activityType活动类型说明：
    101 定金尾款预热，价格显示actualPrice，显示倒计时，距开始时间
    100 定金尾款抢购中 限时预约价 actualPrice，最终价格 finalPrice，原价 originPrice，显示倒计时，到活动结束时间，如果deposit是1展示全款购买按钮，全款购买价格用originPrice
    81 预约抢购预约中，价格展示actualPrice，不展示立即购买，展示立即预约按钮，显示倒计时，到活动结束时间
    80 预约抢购中，价格展示actualPrice，显示倒计时，到活动结束时间
    70 限时抢购，价格展示actualPrice，显示倒计时，到活动结束时间 活动为空时，取actualPrice;
    DSG-20692: 71 限时抢购预热，不再展示倒计时，展示一条活动预告
    75 店铺拼团活动期
    76 店铺拼团预热期 不再展示倒计时，展示一条活动预告-->
    <div class="goods" id="goods">
      <div class="basic-info-wrap">
        <div class="product-tips" v-if="needAppointment">定制商品“一键预约”后将与您联系</div>
        <div class="price-wrap" v-else>
          <!-- 好物拼团 -->
          <!-- <lazy-group-book v-if="isBuyTogether" :priceInfo="priceInfo" :activityInfo="activityInfo"/> -->
          <!-- 带有倒计时 -->
          <div
            class="activity"
            :class="{'salling':activityInfo.activityType === 100,'yuyue': activityInfo.activityType === 81 || activityInfo.activityType === 80 ,'xsqg': activityInfo.activityType === 70}"
            v-if="
              activityInfo &&
                ( activityInfo.activityType === 100 ||
                  activityInfo.activityType === 81 ||
                  activityInfo.activityType === 80 ||
                  activityInfo.activityType === 70 ) ||
                  isBuyTogether"
          >
            <div class="left">
              <img v-if="activityInfo.activityType === 100 || activityInfo.activityType === 101" class='icon' :src="`${$cdnImageUrl}/icon/new/salling.png`" alt="">
              <img v-else-if="activityInfo.activityType === 70" class='icon' :src="`${$cdnImageUrl}/icon/new/xsqg.png`" alt="">
              <div v-else-if="isBuyTogether" class='icon' style='display: flex; flex-direction: row;align-items: center'>
                  <img   :src="`${$cdnImageUrl}/icon/new/hwpt.png`" alt="">
                  <span  class="pintuan">{{activityInfo.clustersNum}}人团</span>
              </div>
              <!-- <span v-if='' class=''>info</span> -->
            </div>
            <div class="right">
              <!-- 结束时间距离现在大于24小时的 -->
              <template v-if="activityInfo.endTime - Date.now()/1000 > 86400">
                <div class="activity-tips">
                  活动时间：{{ activityInfo.startTime | formatDateExceptY(false) }} - {{activityInfo.endTime | formatMonthWithoutSeconds }}
                </div>
              </template>
              <template v-else>
                <div class="activity-tips">{{ activityInfo.activityType | formatActivityType }}</div>
                <div class="countdown">
                  <countdown :color="activityInfo.activityType === 101?'#FF741C':activityInfo.activityType === 100?'#F10C2D':activityInfo.activityType === 80 || activityInfo.activityType === 81?'#00bcc1':''" :activityType="activityInfo.activityType" :endTime="activityInfo.endTime" :startTime="activityInfo.startTime" />
                </div>
              </template>
            </div>
          </div>
          <!-- 专属价 -->
          <template v-if="isExclusive">
            <div class="exclusive-price-label">
              <div class="exclusive-countdown">
                <img class="countdown-img" src="https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/privateMall/product/prod-act-zsj.png"/>
                <span class="title">限时专享</span>
                <van-count-down class="_count" :time="(activityInfo.endTime * 1000 - activityInfo.sysTime)" @finish="countdownFinish">
                      <template #default="timeData">
                        <span class="block">{{ timeData.hours | formatTimeNum }}</span>
                        <span class="colon">:</span>
                        <span class="block">{{ timeData.minutes | formatTimeNum}}</span>
                        <span class="colon">:</span>
                        <span class="block">{{ timeData.seconds | formatTimeNum}}</span>
                      </template>
                </van-count-down>
              </div>
              <div class="prices">
                <div class="current-price">
                  <span class="float-number">￥</span>
                  <span>{{ (priceValue||priceInfo.price ? priceInfo.price : 0)|formatPrice | formatPriceInt }}</span>
                  <span class="float-number">{{ (priceValue||priceInfo.price ? priceInfo.price : 0)|formatPrice | formatPriceFloat}}</span>
                </div>
                <div class="origin-price">
                  ￥{{ priceInfo.originPrice ? priceInfo.originPrice : 0|formatPrice }}
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="normal" :style='{paddingTop: (activityInfo.activityType === 100 || activityInfo.activityType === 70 || isBuyTogether) ? ".24rem" : ".3rem"}'>
              <div class="left">
                <div class='activity-icon' v-if='activityInfo.activityType === 100 || activityInfo.activityType === 70 || isBuyTogether'>
                  <img v-if='activityInfo.activityType === 100' :src="`${$cdnImageUrl}/icon/new/dj.png`"  style='width:.56rem'  alt="">
                  <img  v-if='activityInfo.activityType === 70' :src="`${$cdnImageUrl}/icon/new/msj.png`" style='width:.84rem'  alt="">
                  <img  v-if='isBuyTogether' :src="`${$cdnImageUrl}/icon/new/ptj.png`" style='width:.84rem' alt="">
                </div>
                <div class="current-price">
                  <div class="current">
                    <!-- 非内购环境 或者 内购环境下并且需要展示internalDiscountPrice={type: 'price'} 类型的-->
                    <span class="float-number">￥</span>
                    <span v-if="priceInfo && priceInfo.minPrice">{{ priceInfo.minPrice|formatPrice | formatPriceInt }}<span class="float-number">{{ priceInfo.minPrice|formatPrice | formatPriceFloat}}</span> <span class="range-after">起</span></span>
                    <span v-else>
                      <template>
                        <span>{{ (priceValue||priceInfo.price ? priceInfo.price : 0)|formatPrice | formatPriceInt }}</span>
                        <span class="float-number">{{ (priceValue||priceInfo.price ? priceInfo.price : 0)|formatPrice | formatPriceFloat}}</span>
                      </template>
                    </span>
                    <div v-if="isNG" class="internal-logo"></div>
                  </div>
                  
                  <!-- 暗券 券后价格展示 -->
                  <div class="coupon-price" v-if="getGoodsUseCouponInfo.isCouponReceived && getGoodsUseCouponInfo.bestCoupon && !priceInfo.plusPrice"><span style="font-size: 0.22rem">券后</span><span>￥{{ getGoodsUseCouponInfo.yhprice |formatPrice}}</span></div>
                </div>
                <div class="original-price internal-origin"  v-if="internalOriginPriceShow">
                  ￥{{ priceInfo.originPrice ? priceInfo.originPrice : 0|formatPrice }}
                </div>
              </div>
              <div v-if='!($toggleSwitch.commissionDisplay && priceInfo.commission)' class="right">销量: {{ saleNum | formatSaleNumber}}</div>
            </div>
            <!-- 暗券 优惠券提示 -->
            <div class="coupon-label-msg" v-if="getGoodsUseCouponInfo.isCouponReceived && getGoodsUseCouponInfo.bestCoupon && !priceInfo.plusPrice">
              <svg class="icon-svg" style="width:0.22rem;height:0.22rem;margin-right:0.08rem;color:#ED2856" aria-hidden="true">
                      <use xlink:href="#icon-universal_xiangqing"></use>
              </svg>
              <span>{{ couponLabelMsg }}</span>
            </div>
            <!--定金尾款预热期-->
            <div class="price-wrap-pre" v-if="activityInfo && activityInfo.activityType === 101">
              <div class="price-wrap-pre-content">
                <div class="price-wrap-pre-tag">
                  活动预告
                </div>
                <div class="price-wrap-pre-text">
                  {{baseInfo.activityForecast[0]}}
                  <img :src="`${$cdnImageUrl}/goodsDetail/deposit_detx3.png`" />
                  {{baseInfo.activityForecast[1]}}
                </div>
              </div>
            </div>
          </template>
        </div>
        <template >
          <member-price
          v-if="!!priceInfo.plusPrice"
          :memberPrice="priceInfo.plusPrice"
          :hasMinPrice="priceInfo && priceInfo.minPrice"
          :mStyle="{'margin-left': '0', 'margin-top': '.1rem'}"
          :isBig="true"/>
        </template>
        <!-- 佣金 -->
        <!-- <commission-label
          :storeId="storeInfo?.storeId"
          :mdCode="storeInfo?.mdCode"
          class="commission-w"
          :commissionType="priceInfo.commissionType"
          :commission="priceInfo.maxCommission?priceInfo.maxC∞ommission:priceInfo.commission"
          :bounty="priceInfo.bounty"
          :more='priceInfo && priceInfo.maxCommission'/> -->
        <div v-if="activityInfo && (activityInfo.activityType === 71 || activityInfo.activityType === 76) && baseInfo && baseInfo.activityInfo" class="activity-preview">
          <div class="title">
            <img src="https://cdn09.ehaier.com/shunguang/H5/www/microMall/product/activity-prex2.png" alt="">
          </div>
          <div class="content"><span>{{ baseInfo.activityInfo }}</span></div>
        </div>
        <plus-entrance :plusInfo="plusInfo" v-if="plusInfo?.showPlusEntrance && plusInfo?.additionalSave > 0" @goVipCenter="goVipCenter"></plus-entrance>
          <!-- 优惠券 -->
        <div class="voucher-wrap"  v-if="isVoucher">
          <div class="center" id='voucher-center' style='position: relative;'>
            <template v-if="isVoucherPartCoupon">
              <div class="voucher-container" v-if="couponList.length || couponGiftList.length" @click="fnShowVoucher">
                <ul>
                  <li class="voucher-item"
                      v-for="(item, index) in couponList"
                      :key="index">
                    <span v-if="item.couponType==='DISCOUNT_COUPON'">{{ (Number(item.couponValue)/10).toFixed(1)}}折优惠券</span>
                    <span v-else>{{ item.couponValue | withFloat }}元优惠券</span>
                  </li>
                   <li class="voucher-item"
                      v-for="(item, index) in couponGiftList"
                      :key="'item'+index">
                    <span>礼品券</span>
                  </li>
                </ul>
                <van-icon name="arrow" size=".24rem" color="#9A9A9A" style="margin-top: 0.1rem;"/>
              </div>
            </template>
            <div class="voucher-container rights" v-if="isVoucherPartRights" @click="fnShowRights">  
              <img :src="`${$cdnImageUrl}/icon/new/rights.png`" style='width:14px;' alt="">
              <div :class="{'voucher-tag': true, 'voucher-blue-tag': !rightsList[0].isShare}">权益</div>
              <div class="voucher-rights">| {{rightsList[0].rightsName}}</div>
              <div class="voucher-desc">(以订单提交为准)</div>
              <van-icon name="arrow" size=".24rem" color="#9A9A9A" style="margin-top: 0.1rem;"/>
            </div>
            <div class="discount-container" v-if="discountActivityText?.length" @click="fnShowVoucher">
              <img :src="`${$cdnImageUrl}/icon/new/cd.png`" style='width:14px;' alt="">
              <div class="discount-tag">{{ discountActivityInfo.discountType == 1 ? '凑单' : '满减'}}</div>
              <div class="discount-rights" id="disLegend">{{discountActivityText}}</div>
              <svg class="icon-svg legend-icon" v-if="discountActivityInfo.discountType == 1"  @click.stop="setDisLegendFlag(true)" aria-hidden="true">
                   <use xlink:href="#icon-universal_xiangqing"></use>
              </svg>
              <van-icon v-if='!couponList.length && !couponGiftList.length' name="arrow" size=".24rem" color="#9A9A9A" style="margin-left: auto"/>
            </div>
            <div class="inner-bouble" :style="{top:disLegendTop + 'rem',left:disLegendLeft + 'rem'}" v-show="disLegendFlag">
              <div class="bouble-top" :style="{left:disLegendTopLeft + 'rem'}" ></div>
              <div class="bouble-content">购买多件享受的优惠，需要购买指定的不同商品，不包含同一件商品多件购买。</div>
              <div class="confirm-box" @click="setDisLegendFlag(false)">
                <div class="confirm-btn">知道了</div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail-wrap">
          <div class="detail-title">
            <div class="title">
              <van-skeleton title :loading="!products.productFullName && products.productFullName!==''">
                <span class="zy-tag" v-if="products?.showTags?.includes('ZY')">自营</span>
                <span class="text"  @touchstart="selectTitle"  :style="{'-webkit-user-select':isCanSelectTitle?'text':'none'}">{{ products.productFullName }}</span>
                <!-- <div class="collect-container" v-if="!isExclusive && !$util.isInternalChannel()" @click="fnCollect">
                  <svg class="icon-svg collect-icon" :class="{'active': isCollected}" aria-hidden="true">
                    <use v-bind:xlink:href="isCollected?'#icon-shoucang':'#icon-ic_shoucangpinlun'"></use>
                  </svg> -->
                  <!-- <span class="collect-text">
                    {{isCollected?'已收藏':'收藏'}}
                  </span> -->
                <!-- </div> -->
              </van-skeleton>
            </div>
          </div>
          <div class="newDescribe" v-if="products.sellPoint">
            <span v-for="(item, index) in products.sellPoint" :key="index">
              {{item}}
            </span>
          </div>
          <div class="item-brandlist" v-if="hotSellTag && hotSellTag.listOrder" @click='goToTopPage'><span></span>TOP{{hotSellTag.listOrder}}<strong>{{ hotSellTag.listText }}</strong><i></i></div>
          <div class="notice" v-if='noticeContent'>
            <div class="notice-content">【公告】{{noticeContent}}</div>
          </div>
          <div class="detail-remark" v-if="baseInfo.giftInfo">赠品信息：{{ baseInfo.giftInfo }}</div>
          <div class="deposit-container" v-if="activityInfo && activityInfo.activityType === 100">
            <div class="final-row">
              <div class="left">尾款</div> 
              <div class="right">
                <div class="final-price">
                  <span class="yuan">￥</span>
                  <span class="price-int">{{ priceInfo.tailPrice|formatPrice | formatPriceInt}}</span>
                  <span class="price-float">{{priceInfo.tailPrice|formatPrice | formatPriceFloat}}</span>
                </div>
                <div class="time-area">({{ activityInfo.tailStartTime | formatDateExceptY}} - {{ activityInfo.tailEndTime | formatDateExceptY}}）</div>
              </div>
            </div>
            <div class="process-row">
              <div class="left">流程</div>
              <div class="right">
                1.付订金<div class="process-devider"></div>2.付尾款<div class="process-devider"></div>3.发货
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 新版以旧换新入口 -->
      <RenewedEntry v-if="baseInfo?.renewedInfo?.tradeIn && activityInfo?.activityType !== 100" :type="0" :price="discountRenewedPrice" :isZY="products?.showTags?.includes('ZY')" :discount="baseInfo?.renewedInfo?.tradeInAMT" @goPage="renewedGoPage"/>

      <!-- 优惠活动区域 -->
      <!-- <div class="wrap-devider" v-if="baseInfo.activityInfo || (!isExclusive && couponList.length)"></div> -->
      <!-- 外层sales-wrap 加四个if判断 防止没有dom内容时外层wrap撑起高度 -->
      <div class="sales-wrap" v-if="(isActivity && activityInfo.activityInfo) || isBuyTogether">
        <!-- 活动信息, 限时抢购预热阶段、拼团预热期不显示 -->
        <div class="activity-wrap-container" v-if="isActivity && activityInfo.activityInfo">
          <div class="left">活动</div>
          <div class="activity-wrap">
            <div class="content">
              <!-- <span class="activity-icon" v-if="baseInfo.activityLabel"><img width='9' height='9' src="//cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/goodsDetail/huodong.png" alt=""> -->
              <span  class="activite-text"> {{activityInfo.activityLabel}}</span>
              <!-- </span> -->
              <span>{{activityInfo.activityInfo | formatActivityInfo}}</span></div>
          </div>
        </div>
        <!-- 拼团 规则 预热期不显示 -->
        <div v-if="isBuyTogether" class="voucher-wrap" style="align-items:center; padding: .2rem .24rem;" @click="goGroupRules()">
          <div class="left">玩法</div>
          <div class="center" style="margin-left: 0.24rem;font-size:.26rem; display: inline-block; text-overflow: ellipsis;">
            开团/参团-邀请好友-满员发货（不满员退款）
          </div>
          <van-icon name="arrow" size=".24rem" color="#9A9A9A"/>
        </div>
        <!-- 以旧换新 ** 仅在智家app与三翼鸟app展示 oldForNewFlag -->
        <!-- v-if="$util.isHaierApp() && oldForNewFlag" -->
        <!-- <div class="oldForNew" v-if="oldForNewSwitch">
          <div class="left">
            <div class="label">换新</div>
            <div class="info" @click="handleOldForNew"><span class="oldForNew-icon"></span>旧家电回收，免费估价，急速到账</div>
          </div>
          <van-icon name="arrow" size=".24rem" color="#9A9A9A" @click="handleOldForNew"/>
        </div> -->
      </div>
      <!-- 拼团列表 -->
      <lazy-group-list v-if="isBuyTogether" :productInfo="products" :activityInfo="activityInfo" @chooseGroup="chooseGroup"/>

      <!-- <div class="wrap-devider" v-if="couponList.length||!(sgAttribute && sgStoreAttribute)"></div> -->
      <div class="order-wrap">
        <div class="number-wrap" @click="toggleShowInfo"
            v-if="sgAttribute && sgStoreAttribute">
          <div class="left">已选</div>
          <div class="center">
            <div class="van-ellipsis" v-if="attrLength > 0" style="line-height: initial;">{{ attrValueNames | attrNameFormat}}<span v-if='!isReservation'>, {{productNumber}}件</span></div>
            <div class="van-ellipsis" v-else style="line-height: initial;">请选择</div>
          </div>
          <van-icon v-if='!isReservation' name="arrow" size=".24rem" color="#9A9A9A"/>
        </div>
        <div class="number-wrap" v-if="!sgAttribute || !sgStoreAttribute">
          <div class="left">已选</div>
          <div class="center">
            <Stepper :stepper-value.sync="goodsNum" :disabled="sgStockInfo && (sgStockInfo.bookable ? false : sgStockInfo.stockNum === 0)" :min="sgStockInfo && !sgStockInfo.bookable && sgStockInfo.stockNum === 0 ? 0 : 1" :max="products.isNoLimitStockProduct ? Infinity : sgStockInfo ? sgStockInfo.bookable ? 100 : sgStockInfo.stockNum > 500 ? 500 : sgStockInfo.stockNum : 1" @stepperChange="fnChangeProductNumber"/>
          </div>
        </div>
         <div class="attr-wrap two" v-if="productShowAttrs && productShowAttrs.length >= 3">
          <div class="left">参数</div>
          <div class="center">
            <div class='attr' v-for='(item, index) in productShowAttrs' :key='index'>
              <div class="attr-value">{{ item.attrValue}}</div>
              <div class="attr-name">{{ item.attrName }}</div> 
            </div>
          </div>
        </div>
        <!-- <div @click="changeLocation(true)" class="address-wrap"> -->
        <div @click="openAddr" class="address-wrap">
          <div class="top">
            <div class="left">送至</div>
            <img :src="`${$cdnImageUrl}/goodsDetail/new_location.svg`" alt="" class="location-icon"/>
            <div class="center van-ellipsis">{{ location.region }}</div>
            <van-icon name="arrow" size=".24rem" color="#9A9A9A"/>
          </div>
          <div class="bottom" v-if="sgStockInfo && !isReservation">
            <div class="bottom-left">
                <div
                  class="status"
                  :style='{"color": this.sgStockInfo.bookable ? "#ED2856" : ""}'
                >{{ stockTip }}</div>
                <div class="time" v-if="sgStockInfo.expectTime">{{ sgStockInfo ? sgStockInfo.expectTime : '' }}</div>
            </div>
          </div>
        </div>
        <div class="attr-wrap" v-if="sgStockInfo && sgStockInfo.labels && sgStockInfo.labels.length"  @click="fnOpenDesc">
          <div class="left">服务</div>
          <div class="center service">
            <ul>
              <li :key="index"
                  v-for="(item, index) in sgStockInfo.labels">
                <img :src="`${$cdnImageUrl}/goodsDetail/service_new.png`" alt="" class="fangxin-icon"/>
                <span>{{ item.name}}</span>
              </li>
            </ul>
          </div>
          <van-icon name="arrow" size=".24rem" color="#9A9A9A"/>
        </div>
        <div class="fare-wrap">
          <div class="left">运费</div>
          <div class="center van-ellipsis">{{ priceInfo.ssf ? `￥${priceInfo.ssf}元` : '包邮' }}</div>
        </div>
      </div>
        <!-- 门店信息 -->
        <div class="store-info-wrap" v-checklogin="PlatformTypes.UPLUS | PlatformTypes.SC_H5" v-if="showMdInfo && !$util.isInternalChannel()" @click='fnGoToStore'>
          <div class="left">
            <img :src="`${$cdnImageUrl}/uplus_logo.png`" alt="">
          </div>
          <div class="center">
            <div class="top">
              <div class="title">{{storeInfo.storeName}}</div>
            </div>
            <div class="bottom" v-if='Number(storeInfo.storeType) ===  3'>品质溯源 | 甄选好物</div>
            <div class="bottom" v-else-if='storeInfo.storeAddress'>{{storeInfo.storeAddress||''}}</div>
          </div>
          <div class="right">
            <van-icon name="arrow" size=".24rem" color="#9A9A9A"/>
          </div>
        </div>
      <div class="other-feature" v-if="products.vrUrl">
        <div class="show-3d" v-if="products.vrUrl" @click="fnOpen3D">
          <div class="left">3D体验</div>
          <div class="right">
            <van-icon name="arrow" size=".24rem" color="#9A9A9A"/>
          </div>
        </div>
      </div>
      <div class="wrap-devider" v-if="products.vrUrl || baseInfo.senceH5Url"></div>
    </div>
    <!-- 优惠券 -->
    <van-popup v-model="showVoucherFlag"  position="bottom" get-container="#good-component-container">
        <goods-info-voucher
          :rightsList="[]"
          @hideVoucher="hideVoucher"
          @receiveCoupon="receiveCoupon"
          :finished="finished"
          :vantLoading="vantLoading"
          :discountActivityInfo="discountActivityInfo"
          :discountActivityText="discountActivityText"
          :voucherList="activityInfo?.activityType !== 100 ? voucherList:[]"
          :voucherGiftList="activityInfo?.activityType !== 100 ? voucherGiftList:[]"
          :getGoodsUseCouponInfo="getGoodsUseCouponInfo"
          @goShopDetail="goShopDetail"
        />
    </van-popup>
    <van-popup v-model="showRightsFlag"  position="bottom" get-container="#good-component-container">
        <goods-info-voucher
          :rightsList="rightsList"
          @hideVoucher="hideVoucher"
          @receiveCoupon="receiveCoupon"
          :finished="finished"
          :vantLoading="vantLoading"
          :discountActivityInfo="discountActivityInfo"
          :discountActivityText="discountActivityText"
          :voucherList="[]"
          :voucherGiftList="[]"
          :getGoodsUseCouponInfo="getGoodsUseCouponInfo"
          @goShopDetail="goShopDetail"
        />
    </van-popup>
    <!-- 商品规格 -->
    <van-popup v-model="showInfoFlag" style="height: 9rem; border-radius: 12px 12px 0px 0px;"  position="bottom" get-container="#good-component-container">
     <!-- v-if="sgAttribute && sgStoreAttribute"
      v-show="showInfoFlag" -->
      <attr-modal
        v-if="sgAttribute && sgStoreAttribute"
        :settings='settings'
        :storeInfo="storeInfo"
        :sgAttribute="sgAttribute"
        :sgStockInfo="sgStockInfo"
        :sgStoreAttribute="sgStoreAttribute"
        :checkedAttr="checkedAttr"
        :stepperNum="stepperNum"
        :checkCouponIsAllGet="checkCouponIsAllGet"
        :getGoodsUseCouponInfo="getGoodsUseCouponInfo"
        :hbFqInfo="hbFqInfo"
        :xjFqInfo="xjFqInfo"
        :ioucInfo="ioucInfo"
        :btnType="btnType"
        :hasSubProduct='hasSubProduct'
        :activityInfo="activityInfo"
        :attrLength="attrLength"
        :priceInfo="priceInfo"
        :parentBookable="parentBookable"
        :notSaleStatus="notSaleStatus"
        :baseInfo="baseInfo"
        :products="products"
        :productNumber="productNumber"
        :isExclusive="isExclusive"
        :canSetPrice="canSetPrice"
        @manageSetPrice="manageSetPrice"
        @attrConfirm="attrConfirm"
        @fnShowInfo="fnShowInfo"
        @fnChangeProductNumber="fnChangeProductNumber"
        @changeGoodsNumber="changeGoodsNumber"
        @attrNameChange="attrNameChange"
        @fnSelectAttribute="fnSelectAttribute"
        @addCart="fnAddCart"
        @buy="buy"
        @depositBuy="depositBuy"
        @fullBuy="fullBuy"
        @priceValue="changePriceValue"
        @fnArrivalNotice="fnArrivalNotice"
        @fnHb="fnHb"
      />
    <!-- @priceRange="changePriceRange" -->
    </van-popup>
    <!-- <van-popup v-model="showRulesModal" style=" border-radius: 12px 12px 0px 0px;"  position="bottom" get-container="#app-warp">
      <lazy-rules-modal :rules="'这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则这里是活动规则'"
        @fnShowRules="showRulesModal = false"/>
    </van-popup> -->
    <!-- 虚拟 spu -->
    <van-popup v-model="showSpuFlag" style="height: 8rem; border-radius: 12px 12px 0px 0px;"  position="bottom" get-container="#app-warp">
    <spu-modal
      v-if="spuInfo"
      :productId="productId"
      :spuInfo="spuInfo"
      :sgAttribute="sgAttribute"
      :sgStockInfo="sgStockInfo"
      :sgStoreAttribute="sgStoreAttribute"
      :checkedAttr="checkedAttr"
      :stepperNum="stepperNum"
      :checkCouponIsAllGet="checkCouponIsAllGet"
      :getGoodsUseCouponInfo="getGoodsUseCouponInfo"
      :hbFqInfo="hbFqInfo"
      :xjFqInfo="xjFqInfo"
      :ioucInfo="ioucInfo"
      :btnType="btnType"
      :hasSubProduct='hasSubProduct'
      :activityInfo="activityInfo"
      :attrLength="attrLength"
      :baseInfo="baseInfo"
      :priceInfo="priceInfo"
      :swiperImgs="swiperImgs"
      :productNumber="productNumber"
      :notSaleStatus="notSaleStatus"
      :products="products"
      :isExclusive="isExclusive"
      :canSetPrice="canSetPrice"
      @manageSetPrice="manageSetPrice"
      @attrConfirm="spuConfirm"
      @fnShowInfo="fnShowInfo"
      @fnChangeProductNumber="fnChangeProductNumber"
      @attrNameChange="attrNameChange"
      @fnSelectSpu="fnSelectSpu"
      @addCart="fnAddCart"
      @buy="buy"
      @depositBuy="depositBuy"
      @fullBuy="fullBuy"
      @priceValue="changePriceValue"
      @fnArrivalNotice="fnArrivalNotice"
      @fnHb="fnHb"
    />
    <!-- @priceRange="changePriceRange" -->
    </van-popup>
    <!-- 地址选择 -->
    <van-popup v-model="showChooseLoaction" position="bottom" :style="{height:'10rem', 'border-radius': '12px 12px 0 0'}" get-container="#app">
      <AddrSelect v-if="showChooseLoaction" :storeId="addrStoreId" @success="addressSucess" @close="showChooseLoaction = false"/>
    </van-popup>
    <!-- <lazy-addr-list ref="addrList" :storeId="addrStoreId" @handleLocation="handleLocation"></lazy-addr-list> -->
    <!-- 服务说明 -->
    <van-popup v-model="showDescription" position="bottom" @click="showDescription = false" get-container="#good-component-container">
      <div class="description">
        <div class="content" @click.stop>
          <div class="title">
            <div class="left">
              <img :src="`${$cdnImageUrl}/icon/new/service-title.png`" alt="">
              <span>售前售后 安心无忧购物</span>
            </div>
            <div class="right"
                 @click="showDescription = false">
             <!-- <img src="@/assets/imgs/common/control-close.png" alt="" /> -->
              <svg class="icon-svg" aria-hidden="true">
                <use :xlink:href="$globalIcon.closeIconNew"></use>
              </svg>
            </div>
          </div>
          <ul>
            <li v-for="(item,index) in descriptionList" :key="index" @click.stop='item.textId && $router.push(`documentInfo?id=${item.textId}`)'>
              <div class="tit">
                <!-- <div class="img"><img :src="`${$cdnImageUrl}/cart/icon-tag.png`"
                       alt=""></div> -->
                <div class="text">{{item.n}}</div>
                <van-icon v-if='item.textId' name="arrow" size=".24rem" color="#666666"/>
              </div>
              <div class="desc">{{item.s}}</div>
            </li>
          </ul>
          <div class="des-devider"></div>
        </div>
           <div class="des-btn-box"><div class="des-btn" @click="showDescription = false"><span>我知道了</span></div></div>
      </div>
    </van-popup>
    <!-- 白条说明 -->
    <!-- <van-action-sheet 
      :round="false"
      v-model="showIoucAction"
      class="close-icon__bill"
      title="白条分期"
      get-container="#good-component-container"
      :close-icon="'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAABYWlDQ1BrQ0dDb2xvclNwYWNlRGlzcGxheVAzAAAokWNgYFJJLCjIYWFgYMjNKykKcndSiIiMUmB/yMAOhLwMYgwKicnFBY4BAT5AJQwwGhV8u8bACKIv64LMOiU1tUm1XsDXYqbw1YuvRJsw1aMArpTU4mQg/QeIU5MLikoYGBhTgGzl8pICELsDyBYpAjoKyJ4DYqdD2BtA7CQI+whYTUiQM5B9A8hWSM5IBJrB+API1klCEk9HYkPtBQFul8zigpzESoUAYwKuJQOUpFaUgGjn/ILKosz0jBIFR2AopSp45iXr6SgYGRiaMzCAwhyi+nMgOCwZxc4gxJrvMzDY7v////9uhJjXfgaGjUCdXDsRYhoWDAyC3AwMJ3YWJBYlgoWYgZgpLY2B4dNyBgbeSAYG4QtAPdHFacZGYHlGHicGBtZ7//9/VmNgYJ/MwPB3wv//vxf9//93MVDzHQaGA3kAFSFl7jXH0fsAAALKSURBVGgF7ZpLjhMxEIYnL7HN7COFKyDI4wAMgkvMMeYQHGN2nAAkWLLIA8SSzSzYJCwn+7yoX+rKmMiOXW5Xs6Baatnttqvq+512t+1cXdlhCpgCpoApYAqYAqaAKWAKmAI5CrRyGo1Go7fH4/GWzk2v13s/m81+5diRtplOp8+32+1dq9Xq03m/XC4/SW2IgQF7OBw+Oo4eu93uzXw+/+6UFc9OJpOXu93uCxnus/F2u/1OCt3mxqkpevas7jUCQUBn5cUufbAw7okl6jMHeOOx2teCDsFWwL5YPOE9FYmB8cxS88cnE6dccehLsIihiuUUQEpGDIwBqtPpvCHjPnWLQUdgN4ghZ7AUD1qs4ng8frXf7z/T9WkQ4XsQgway17kDWQLszWKx+Ob4S85mA8ODRmCaQiLmWsClobVhiwCXgm4CthhwXeimYIsC50I3CVscWArdNKwKcCo06mm91mA7dNQepUOGY6+sql3xd3goHi5XA4aDCDTH4Ka1PlhcQ6G8KjCcCqDVYRGPOnAidCOwiEU8eUAj6UHz1qiwKXWkfn31o4H4GknKIq8e1xRmQNmTAtfQpbwqsACWY1SHVgOOwPICwjWTOqkqtApwDBaLfgCkZSHMpxuFLg6cAssLA9Urq1HoosASWP4JNw1dDDgH9l9AFwGuA3sG/ddCO9+jtNhAVhs4Aiv6gop8hhaBrvWlhQBLTvEwmGG1Ez3q9C5n+/AFn1yQk2b3cKw3NJdp69jOAtaE5V7T8iEGrrYsf1Bg6pP3GDRttbyQ7j6In2HszzYBi56OPdNVLKiafIiBsRntsS4ajT3tg0WXoAOxBG3hRg7w/ZlFNVj2E4LGvwC4TmraSa3I9dbr9cNgMJjTNdp+pefolgL6yfe10tVq9Xs4HH6gfx88I9AH2v2/k+7+a8Vmdk0BU8AUMAVMAVPAFDAFTIH/QYE//MMfje5LxscAAAAASUVORK5CYII='"
    >
      <div class="iouc-subtitle">打白条请到支付页面</div>
      <div class="iouc-table">
        <div class="iouc-cell" v-for="(item, index) in ioucInfo.costInfo" :key="index">
          <div class="each-price">￥{{item.eachPrinAndFee}} &times; {{item.num}}期<span style="font-size: 0.22rem;">(含服务费)</span></div>
          <div class="fee"><pre> 每期￥{{item.fee}} 费率：{{item.rate}}%</pre></div>
        </div>
      </div>
      <div v-if="ioucInfo.applyStatus==2 || ioucInfo.applyStatus==3" class="iouc-buttom" @click="goBaitiao">申请激活</div>
      <div v-if="ioucInfo.applyStatus==0" class="iouc-buttom" @click="goBaitiao">申请中</div>
      <div v-if="ioucInfo.applyStatus==1" class="iouc-buttom" @click="goBaitiao">可用额度：￥{{ioucInfo.crdComAvailAmt}}</div>
    </van-action-sheet> -->
  </div>
</template>

<script>
// { 'rate': 0.65, 'fee': 3.24, 'num': 3, 'eachPrinAndFee': 169.57 }
import countdown from './countdown'
import goodsInfoVoucher from './goods-info-voucher'
import attrModal from './attr-modal'
import spuModal from './spu-modal'
import Stepper from './stepper'
import { mapGetters, mapState } from 'vuex'
import { autoProductMsg } from '@/http/service/chat'
import RenewedEntry from '@/components/renewedEntry/index.vue'
// import utils from '@/utils/utils'
const memberPrice = () => import('@/components/memberPrice')
const commissionLabel = () => import('@/components/commissionLabel/index')
const lazyGroupBook = () => import('./goods-info-price-groupbook');
const AddrSelect = () => import('@/components/addrSelect/addrSelect.vue')
const lazyGroupList = () => import('./goods-info-group-list.vue')
// const lazyRulesModal = () => import('./goods-activity-rules-modal')
import config from '@/config/index';
import { PlatformTypes } from '@/config/constMaps'
import plusEntrance from './plus-entrance'

export default {
  components: {
    countdown,
    goodsInfoVoucher,
    // goodsInfoInfo,
    AddrSelect,
    attrModal,
    Stepper,
    spuModal,
    RenewedEntry,
    memberPrice,
    commissionLabel,
    lazyGroupBook,
    lazyGroupList,
    // lazyRulesModal,
    plusEntrance,
  },
  props: [
    'settings',
    'needAppointment',
    'products',
    'sgAttribute',
    'sgStoreAttribute',
    'sgStoreAttributeItem',
    'activityInfo',
    'baseInfo',
    'priceInfo',
    'sgStockInfo',
    'productNumber',
    'attrValueNames',
    'location',
    'couponList',
    'couponGiftList',
    'rightsList',
    'voucherList',
    'voucherGiftList',
    'checkCouponIsAllGet',
    'getGoodsUseCouponInfo',
    'finished',
    'vantLoading',
    'descriptionList',
    'productId',
    'hbFqInfo',
    'xjFqInfo',
    'ioucInfo',
    'checkedAttr',
    'isExclusive',
    'canSetPrice', // 是否能设置专属价
    'storeInfo',
    'isCanSelectTitle',
    'btnType',
    'hasSubProduct',
    'attrLength', // 规格已选数量
    'spuInfo', // spu 信息
    'swiperImgs', // 商品轮播图
    'parentBookable', // 多规格商品 主商品预定状态
    'notSaleStatus', // 区域不销售/不配送 状态
    'visitStore', // 店铺跳转携带 id
    'noticeContent', // 通告
    'isCollected', // 收藏状态
    'oldForNewFlag', // 以旧换新开关
    'trkOrigin', // 上级页面来源
    'plusInfo', // plus会员注册入口信息
    'discountActivityInfo', //折扣信息
    'discountActivityText', // 凑单折扣文案
    'productShowAttrs', // 展示的参数
    'hotSellTag', // 热销榜
  ],
  data () {
    return {
      expandNotice: false,
      goodsNum: 0,
      // btnType: 1, // 0:加入购物车 1:立即购买
      showVoucherFlag: false,
      showRightsFlag: false,
      showInfoFlag: false,
      showSpuFlag: false, // spu弹窗展示状态
      showChooseLoaction: false,
      showDescription: false,
      showIoucAction: false,
      // showRulesModal: false, // 活动规则显示状态
      stepperNum: 1, // 暂存进步器的value
      newStockNum: '', // 监听传进来的stockNum
      addrLoad: false,
      // priceValueRange: '',
      priceValue: '',
      initStatus: false, // 针对要求 多规格商品 初次进入页面 未选择规格 时展示 现货
      sellPoint: ['风冷无霜', '能效双变频', '只能控制', '高温除菌', '节能高效', '风冷无霜', '能效双变频', '只能控制', '高温除菌'],
      tagList: [
        { color: '#f10', plain: false, context: '自营' },
        { color: '#467bf1', plain: false, context: '分期免息' },
        { color: '#f2826a', plain: true, context: '智家优选' },
        { color: '#f2826a', plain: true, context: '智家优选' },
        { color: '#f2826a', plain: true, context: '智家优选' },
        { color: '#f2826a', plain: true, context: '智家优选' },
        { color: '#f2826a', plain: true, context: '智家优选' },
        { color: '#ffe1e1', text: '#ad0000', plain: true, context: '商家免邮' }
      ],
      addrStoreId: '',
      showCommissionInfo: false,
      disLegendFlag: false,
      disLegendTop: '0',
      disLegendLeft: '0',
      disLegendTopLeft: '2.48',
      disLegendPositionFlag: false,
      PlatformTypes
    }
  },
  created () {
    // this.fnOpenIouc()
    // 针对多规格商品特殊处理 ==>多规格进入单品页时计算最低价格
    // if (this.hasSubProduct && !this.spuInfo) {
    //   let min = 100000000
    //   this.sgStoreAttribute.forEach(ii => {
    //     if (ii.price < min) min = ii.price
    //   })
    //   this.changePriceRange(min)
    // }
  },
  computed: {
    ...mapState('chat', ['isTimLogin']),
    // getGoodsUseCouponInfo() {
    //   let type = this.voucherList.some(item => item.marking === 'sheng') ? 'sheng' : this.voucherList.some(item => item.marking === 'cou') ? 'cou' : ''
    //   let yhprice = 0; let buyNum = 1;
    //   this.voucherList.forEach(item => {
    //     if (item.marking === 'sheng' || item.marking === 'cou') {
    //       yhprice += item.couponAmount
    //       buyNum = item.buyNum
    //     }
    //   })
    //   return {
    //     type,
    //     buyNum,
    //     price: this.priceInfo.price * buyNum - yhprice,
    //     yhprice
    //   }
    // },
    ...mapGetters([
      // 'ucId',
      'accessToken',
    ]),
    // 预约商品 
    isReservation () {
      // 有值，且有时间
      return  !!this.settings.showBook && !!this.settings.showBook.timestamp
    },
    couponLabelMsg() {
      let text = ''
      if (this.getGoodsUseCouponInfo.isCouponReceived && this.getGoodsUseCouponInfo.bestCoupon && !this.priceInfo.plusPrice) {
        const { couponType, couponValue, limitAmount, endTime, validityPeriod } = this.getGoodsUseCouponInfo.bestCoupon
        if (couponType === 'DISCOUNT_COUPON') {
          text = `您有一张${(Number(couponValue)/10).toFixed(1)}折的优惠券`
        } else {
          let _limitAmount =  Number(limitAmount) ? `满${Number(limitAmount)}元` : ''
          text = `您有一张${_limitAmount}减${Number(couponValue)}的优惠券`
        }
        if (validityPeriod) {
          text = `${text}，${validityPeriod}`
        } else if (endTime) {
          text = `${text}，有效期至${endTime?.split(' ')[0]?.replaceAll('-', '.') || endTime}`
        }
      }
      return text
    },
    
    /**
     * 以旧换新折后价
     */
    discountRenewedPrice(){
      if(this.activityInfo?.activityType === 100){
        return Math.max(this.priceInfo?.originPrice - this.baseInfo?.renewedInfo?.tradeInAMT, 0).toFixed(2)
      }else if(this.isVoucherPartCoupon){
        return Math.max(this.getGoodsUseCouponInfo.price - this.baseInfo?.renewedInfo?.tradeInAMT, 0).toFixed(2)
      }else{
        return Math.max(this.priceInfo?.finalPrice - this.baseInfo?.renewedInfo?.tradeInAMT, 0).toFixed(2)
      }
    },

    /**
     * @description 以旧换新开关
    */
    oldForNewSwitch() { 
      let ret = false
      if(this.oldForNewFlag && !this.$util.isShopKeeper() && !this.$util.isSyBirdMP() && !this.$util.isScMp() && !this.$util.isInternalChannel()) {
        ret = true
      }
      return ret
    },
    showMdInfo() {
      return this?.storeInfo?.storeId
    },
    /**
     * 是否为内购环境，使用此计算属性而非直接使用$util.isInternalChannel()是为了便于局部调试内购样式
     */
    isNG() {
      return this.$util.isInternalChannel()
      // return true
    },
    stockTip () {
      return  this.sgStockInfo.bookable? '预售': this.sgStockInfo.hasStock ? '现货' : '无货'
    },
    internalOriginPriceShow() {
      // 内购环境下，商品列表页有划线价展示划线价，无划线价不展示，如果低于内购价格也不展示；
      let ret = false
      if(this.priceInfo?.originPrice && this.priceInfo.originPrice > this.priceInfo.price){
        ret = true
      }
      return ret
    },
    // internalDiscountPrice() {
    //   // 内购环境下，展示折扣，折扣=内购价/划线价*10，五入，取小数点2位显示；如果超出10折按照实际价格展示；如果划线价为空，则展示10折；
    //   const op = this.priceInfo.originPrice // 划线价格、原价、平台价格
    //   const ap = this.priceInfo.price // 内购价格、实际价格
    //   // const op = 90
    //   // const ap = 70
    //   if (!ap) { // 内购价格为空(null\undefined\0)
    //     return null
    //   } else {
    //     if (!op) { // 划线价为空(null\undefined\0)，则展示10折
    //       return {type: 'discount', value: 10}
    //     } else {
    //       const discount = ap / op * 10
    //       return {type: 'discount', value: discount}
    //     }
    //     // else if (op <= ap) { // 超出10折按照实际价格展示
    //     //   return {type: 'price'}
    //     // }
    //   }
    // },
    showIouc () {
      // 如果有手机号则显示白条
      return true
    },
    saleNum() {
      // 优先使用动态接口中的销量
      return (this.baseInfo.saleNum === undefined || this.baseInfo.saleNum === null) ? this.products.saleNum : this.baseInfo.saleNum
    },
    mId() {
      return this.$store.getters.mId
    },
    /**
     * 是否展示优惠券
     */
    isVoucher() {
      return this.isVoucherPartCoupon || this.isVoucherPartRights || this.discountActivityText?.length
    },
    isVoucherPartCoupon() {
      return (this.couponList.length || this.couponGiftList.length) && this.activityInfo?.activityType !== 100
    },
    isVoucherPartRights() {
      return this.rightsList.length
    },
    /**
     * 是否展示活动
     */
    isActivity() {
      // return fals
      return this.activityInfo && this.activityInfo.activityType !== undefined && !(this.activityInfo.activityType === 71 || this.activityInfo.activityType === 76)
    },
    /**
     * 是否展示拼团
     */
    isBuyTogether() {
      return this.activityInfo && (this.activityInfo.activityType === 75)
    },
    /**
     * 是否展示以旧换新
     */
    isOldForNew() {
      return this.$util.isHaierApp() && this.oldForNewFlag
    },
  },
  filters: {
    formatTimeNum(val) {
      // console.log(val, 'filter==================')
      return val > 9 ? val : '0' + val
    },
    formatSaleNumber(v) {
      const nv = Number(v);
      const nvn = (nv / 10000).toFixed(1) + '万'
      return nv <= 9999 ? nv : nvn
    },
    formatPriceInt(v) {
      return v.split('.')[0];
    },
    formatPriceFloat(v) {
      return '.' + v.split('.')[1];
    },
    formatActivityInfo(value) {
      return value ? value?.replace(/【(.+?)】/, '') : ''
    },
    withFloat(value) {
      const v = String(value)
      const arr = v.split('.')
      if (arr && arr.length > 1 && arr[1] !== '00' && arr[1] !== '0') {
        return value
      }
      return arr[0]
    },
    formatActivityType (value) {
      let _str
      if (value === 101) {
        // 101 定金尾款预热 距开始时间
        _str = '距活动开始还剩'
      } else if (value === 100) {
        // 100 定金尾款抢购中 到活动结束时间
        _str = '距活动结束还剩'
      } else if (value === 81) {
        // 81 预约抢购预约中 到活动结束时间
        _str = '距活动开始还剩'
      } else if (value === 80) {
        // 80 预约抢购中 到活动结束时间
        _str = '距活动结束还剩'
      } else if (value === 70) {
        // 70 限时抢购 到活动结束时间
        _str = '距活动结束还剩'
      } else if (value === 71) {
        // 71 店铺限时抢购预热 到活动开始时间
        _str = '距活动开始还剩'
      } else if (value === 75) {
        // 拼团
        _str = '距活动结束还剩'
      }
      return _str
    },
    attrNameFormat(v) {
      return v.replace(/,/g, ' ')
    }
  },
  methods: {
    goToTopPage() {
      this.$router.push({
        path: '/smartProListTop',
        query: {
          cateId: this.hotSellTag.hotSellCateId,
          subCateId: this.hotSellTag.hotSellSubCateId,
        }
      })
    },
    async openConversation(info) {
      try {
        if (!this.isTimLogin) await this.$store.dispatch('chat/timLogin')
      } catch (err) {
        console.log(err)
      }
      this.sendMessage(info)
    },
    fnHb(hbIndex,payNum){
      this.$emit('fnHb',hbIndex,payNum)
    },
    sendMessage(info) {
      const params = {
        productId: this.productId,
        productName: this.products.productFullName,
        productPrice: this.priceInfo.price ? this.priceInfo.price : 0,
        productImg: this.swiperImgs[0]?.baseImage || this.swiperImgs[0]?.img || (typeof this.swiperImgs[0] === 'string' ? this.swiperImgs[0] : 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/img_bg.png'),
        params: this.getShareParams()
      }
      autoProductMsg({
        from: this.mId,
        to: `${info.memberId}`,
        productId: this.productId,
        productInfo: JSON.stringify({
          type: 3,
          text: '[商品卡片]',
          product: params
        })
      }).finally(() => {
        this.$router.push({
          path: '/conversation',
          query: {
            userId: info.memberId,
            userName: info.name
          }
        })
      })
    },
    getShareParams() {
      const query = {
        ...this.getCleanQuerys(),
        productId: this.productId,
      }

      if (this.mId) {
        query.storeId = this.mId
        query.shareId = this.mId
      }
      if (this.storeInfo && this.storeInfo.mdCode) {
        query.mdCode = this.storeInfo.mdCode
      }
      return query
    },

    /** 以旧换新入口 */
    async renewedGoPage(){
      if (this.$route.query.tradeInId) {
        this.$emit('fnGoBuy', 1)
        return
      }
      let url = this.baseInfo.renewedInfo.tradeInLink
      let { mdCode, visitStore } = this.$route.query
      // this.$util.openNewWindow(url, true)
      let proList = {
        sku: this.products.sku,
        num: 1,
        exclusivePriceId: this.$route.query?.exclusiveId || ''
      }
      if(this.$util.isShopKeeper() || (visitStore && mdCode)){
        // 非自营商品 增加mdCode字段
        if (!this.products?.showTags?.includes('ZY')) {
          proList.mdCode = this.storeInfo?.mdCode || undefined
        }
      }
      let phone = this.$store.state.userInfo.phone;
      let fillinOrderPriority = 0; //单品页 不会代客下单

      this.$store.dispatch('goPageByType', {
        type: 103,
        params: {
          proList,
          sourceType: this.$store.state.sourceType,
          sourceCode: this.$store.state.sourceCode,
          phone,
          fillinOrderPriority
        },
      })
    },

    /**
     * 跳转拼团规则页
     */
    goGroupRules() {
      this.$router.push('/groupBookingRules');
    },
    gioHZ20017Click() {
      this.$emit('gioHZ20017')
    },
    fnGoToStore() {
      this.gioHZ20017Click()
      this.$util.gioTrackWithVariable('MB15622', {
        storeId: this.storeInfo.storeId + ''
      })
      if (this.$util.isShopKeeper()) {
        this.$util.gioTrackWithVariable('YG20102', {
          product_id: this.productId,
          product_name: this.products?.productFullName,
          store_id: this.storeInfo?.storeId,
          md_code: this?.storeInfo?.mdCode,
        }, true)
      }
      if (this.$util.isSyBird()) {
        this.$util.gioTrackWithVariable('BD20275', {
          product_id: this.productId,
          product_name: this.products?.productFullName,
          md_code: this.storeInfo?.mdCode,
          store_id: this.storeInfo?.storeId,
          origin: this.trkOrigin,
        })
      }
      this.$router.push({
        path: '/shopDetail',
        query: {
          storeId: this.storeInfo.storeId,
          mdCode: this?.storeInfo?.mdCode || ''
        },
      })
    },
    toggleShowInfo() {
      // 预约商品禁止点击规格弹窗
      if (this.isReservation) {
        return
      }
      this.$emit('toggleShowInfo', 0)
    },
    /** 拼团活动参团 */
    chooseGroup(groupId) {
      this.$emit('toggleShowInfo', groupId)
    },
    /**
     * @description 多规格确定回调
     */
    attrConfirm({type}) {
      if (type === 'original') {
        this.$emit('fnGoBuy', 1)
        return
      }
      switch (this.btnType) {
        case 0:
        // 加购物车
          this.fnAddCart()
          break;
        case 1:
        case 9:
        // 立即购买
          this.$emit('fnGoBuy', 1)
          break;
        case 2:
        // 到货通知
          this.showInfoFlag = !this.showInfoFlag
          this.$emit('fnArrivalNotice')
          break;
        case 3:
        // 马上预定
          this.$emit('bookableBuy')
          break;
        case 4:
        // 全款支付
          this.$emit('fnGoBuy', 1)
          break;
        case 5:
        case 10:
        case 11:
        // 定金支付、拼团
          this.$emit('fnGoBuy', 0)
          break;
        case 8:
        // 立即预约
          this.showInfoFlag = !this.showInfoFlag
          this.$emit('fnReserve')
          break;
        default:
          this.showInfoFlag = !this.showInfoFlag
          break;
      }
    },
    spuConfirm() {
      switch (this.btnType) {
        case 0:
        // 加购物车
          this.fnAddCart()
          break;
        case 1:
        case 9:
        // 立即购买
          this.$emit('fnGoBuy', 1)
          break;
        case 2:
        // 到货通知
          this.showSpuFlag = !this.showSpuFlag
          this.$emit('fnArrivalNotice')
          break;
        case 3:
        // 马上预定
          this.$emit('bookableBuy')
          break;
        case 4:
        // 全款支付
          this.$emit('fnGoBuy', 1)
          break;
        case 5:
        case 10:
        case 11:
        // 定金支付、拼团
          this.$emit('fnGoBuy', 0)
          break;
        case 8:
        // 立即预约
          this.showSpuFlag = !this.showSpuFlag
          this.$emit('fnReserve')
          break;
        default:
          this.showSpuFlag = !this.showSpuFlag
          break;
      }
    },
    fnArrivalNotice() {
      // 到货通知
      if (this.spuInfo) {
        this.showSpuFlag = !this.showSpuFlag
      } else {
        this.showInfoFlag = !this.showInfoFlag
      }
      this.$emit('fnArrivalNotice')
    },
    buy() {
      // 立即购买
      this.$emit('fnGoBuy', 1)
    },
    depositBuy() {
      // 定金支付
      this.$emit('fnGoBuy', 0)
    },
    fullBuy() {
      // 全款支付
      this.$emit('fnGoBuy', 1)
    },
    /**
     * 收藏
    */
    fnCollect() {
      this.$emit('fnCollect')
    },

    addressSucess(){
      this.showChooseLoaction = false
      this.handleLocation()
    },
    /**
     * 打开地址选择弹窗
    */
    openAddr() {

      // if (this.sgStockInfo.skuDisplayState === 4) {
      //   // 私域情况下 超出门店配送范围 锁定 省市区级联只能选配送范围内的地址
      //   if (this.storeInfo) {
      //     this.addrStoreId = this.storeInfo.storeId
      //   }
      // } else {
      //   this.addrStoreId = ''
      // }
      this.addrStoreId = this.visitStore || ''
      this.showChooseLoaction = true
      return
      // if (!this.addrLoad) {
      //   lazyAddrList().then(() => {
      //     this.addrLoad = true;
      //     this.$nextTick(() => {
      //       if (this.$refs.addrList) {
      //         this.$refs.addrList.openAddr()
      //       }
      //     })
      //   })
      //   return;
      // }
      // this.$refs.addrList?.openAddr()
    },
    selectTitle() {
      this.$emit('titleSelectOption', true)
    },
    countdownFinish() {
      this.$emit('countdownFinish')
    },
    attrNameChange(v) {
      this.$emit('attrNameChange', v)
    },
    fnChangeProductNumber(value) {
      this.stepperNum = value;
      this.$emit('fnChangeProductNumber', value)
    },
    changeGoodsNumber(value) {
      this.stepperNum = value;
      this.$emit('changeGoodsNumber', value)
    },
    fnShowVoucher () {
      this.showVoucherFlag = !this.showVoucherFlag
    },
    fnShowRights () {
      this.showRightsFlag = !this.showRightsFlag
    },
    hideVoucher () {
      this.showVoucherFlag = false
      this.showRightsFlag = false
    },
    fnShowInfo (value) {
      // this.btnType = value // 0:加入购物车 1:立即购买
      // 如果spu信息存在 走虚拟spu弹窗展示逻辑 否则走多规格逻辑
      if (this.spuInfo) {
        this.showSpuFlag = !this.showSpuFlag
        this.$emit('titleSelectOption', !this.showSpuFlag)
      } else {
        this.showInfoFlag = !this.showInfoFlag
        this.$emit('titleSelectOption', !this.showInfoFlag)
      }
    },
    showInfo() {
      // 重置操作按钮类型
      this.$emit('resetBtnType')
      this.showInfoFlag = !this.showInfoFlag
    },
    // changeLocation (changeModal) {
    //   this.showChooseLoaction = changeModal
    // },
    /**
     * @description 点击选择所在地区 确认关闭回调
     */
    handleLocation () {
      // this.showChooseLoaction = false
      // console.log('位置选择:===>', data)
      // this.$store.commit('setLocationInfo', {
      //   ...data,
      //   // type: 'userSelected'
      // })
      let gioParam = {
        storeId: this.storeInfo && this.storeInfo.storeId ? this.storeInfo.storeId + '' : 'null',
        deliverStreet: 'null'
      }
      // if (this.storeInfo && this.storeInfo.storeId) {
      //   gioParam.storeId = (this.storeInfo.storeId + '') || 'null'
      // }
      let regionArr = this.$util.strJSONParse(localStorage.getItem('location'), {})?.region?.split(' ')
      if (regionArr?.length === 4) {
        gioParam.deliverStreet = regionArr[3] ? regionArr[3] + '' : 'null'
      }
      this.$util.gioTrackWithVariable('MB15619', gioParam)
      this.$emit('handleLocation')
      try {
        gio('track', 'ProView', {
          deliverStreet: this.$util.strJSONParse(localStorage.getItem('location'), {}).township,
          deliverDistrict: this.$util.strJSONParse(localStorage.getItem('location'), {}).district,
          deliverCity: this.$util.strJSONParse(localStorage.getItem('location'), {}).city,
          deliverProvince: this.$util.strJSONParse(localStorage.getItem('location'), {}).province
        })
      } catch (error) {

      }
    },
    fnSelectAttribute (data) {
      // // 多规格 规格未选完 不刷新
      // if (!data.price) return
      this.stepperNum = this.stepperNum ? this.stepperNum : (this.newStockNum > 0 ? 1 : 0);
      this.$emit('fnSelectAttribute', data, this.stepperNum)
    },
    /**
     * @description 切换选择 spu产品
    */
    fnSelectSpu(obj) {
      this.$emit('fnSelectSpu', obj)
    },
    fnAddCart () {
      this.$emit('fnAddCart')
    },
    fnGoBuy () {
      this.$emit('fnGoBuy')
    },
    receiveCoupon (data) {
      this.$emit('receiveCoupon', data)
    },
    goBaitiao () {
      this.$emit('goBaitiao')
    },
    /**
     * @description 服务说明
     */
    fnOpenDesc () {
      this.showDescription = true
      this.$emit('getDes')
    },
    /**
     * @description 设计师推荐方案
     */
    // async fnOpenProgram () {
    //   this.$util.gioTrackWithVariable('MB15624')
    //   const sceneUrl = await this.$store.dispatch('getIntactSceneUrl', this.baseInfo.sceneUrl)
    //   if (!sceneUrl) return
    //   this.$store.dispatch('goPageByType', {
    //     type: 5,
    //     params: sceneUrl
    //   })
    //   // this.$router.push({
    //   //   path: 'itSoluteList',
    //   //   query: {
    //   //     productId: this.productId,
    //   //   },
    //   // })
    // },
    /**
     * @description 展示白条方案
     */
    // fnOpenIouc () {
    //   this.$emit('fetchIoucCost')
    // },
    /**
     * @description 3D展示
     */
    fnOpen3D () {
      this.$util.openNewWindow(this.products.vrUrl, true)
    },
    handleOldForNew() {
      if (this.$util.isHaierApp()) {
      // U+ 登陆处理
        this.$store.dispatch('handleUpAuth').then(isLogin => {
        // 登陆正常 调用加购接口
          if (!isLogin) {
            this.$store.dispatch('doLogin')
            return
          }
          this.toOldForNew()
        }).catch(e => { console.log(e) });
      } else {
        if (!this.$store.getters.getLoginStatus) {
          this.$store.dispatch('doLogin')
          return
        }
        this.toOldForNew()
      }
    },
    /**
     * @description 跳转以旧换新页面
    */
    toOldForNew() {
      if(this.oldForNewSwitch) {
        const storeId = this.storeInfo?.mdCode || '' // MDM系统门店88码
        const sourceSystem = 109 // 系统来源
        const token = this.accessToken || '' // 用户中心token
        const backUrl = encodeURIComponent(document.URL)
        const loginUrl = `${config.HOST}/sgmobile/login?callBackPath=`+ backUrl // 以旧换新默认登录成功后返回单品页
        let targetUrl = `http://testdb.haier.net/renewalh5?sourceSystem=${sourceSystem}&storeId=${storeId}&token=${token}&backUrl=${backUrl}&loginUrl=${loginUrl}` // 测试环境以旧换新地址
        if(this.$util.isProdOrPreEnv()) {
          targetUrl = `https://barter.haier.net/renewalh5?sourceSystem=${sourceSystem}&storeId=${storeId}&token=${token}&backUrl=${backUrl}&loginUrl=${loginUrl}` // 正式地址待提供
        }
        this.$util.openNewWindow(targetUrl, true);
        this.$util.trackWithVariable({
          platformConf: {
            [PlatformTypes.UPLUS]: {
              id: 'HZ20057'
            },
            [PlatformTypes.SYN_APP | PlatformTypes.SYN_H5]:{
              id: 'BD20582'
            },
            [PlatformTypes.COMMON]:{
              id: 'HZ20057'
            }
          },
          commonParams: ['store_code', 'md_code','product_id','product_name']
        }, {
          store_code: this.storeInfo?.storeCode || '',
          md_code: this.storeInfo?.mdCode || '',
          product_id: this.products?.productId || '',
          product_name: this.products?.productFullName || '',
        }).then(res => {
          console.log('report res', res)
        })
      }
      // // 判断三翼鸟app与智家环境跳转不同路径
      // if (this.$util.isUplus()) {
      //   // 正式环境地址
      //   this.$util.openNewWindow(`mpaas://vipValueCenter?needAuthLogin=1#/readyValue`, true, true);
      //   // // 测试环境地址
      //   // this.$util.openNewWindow(`https://hzytest.haier.com/cn/vipcode/readyValue?resource=uhome&needAuthLogin=1&container_type=3`, true, true, false);
      // } else if (this.$util.isSyBird()) {
      //   // 正式环境地址
      //   this.$util.openNewWindow(`https://hzy.haier.com/cn/distcord/readyValue?resource=uhome&needAuthLogin=1&container_type=3`, true, true, false);
      //   // // 测试环境地址
      //   // this.$util.openNewWindow(`https://hzytest.haier.com/cn/vipcode/readyValue?resource=uhome&needAuthLogin=1&container_type=3`, true, true, false);
      // }
    },
    sortList(arr) {
      let len = arr.length;
      for (var i = 0; i < len; i++) {
        for (var j = 0; j < len - 1 - i; j++) {
          if (arr[j].tagOrder > arr[j + 1].tagOrder) {
            var temp = arr[j + 1]
            arr[j + 1] = arr[j]
            arr[j] = temp
          }
        }
      }
      return arr
    },
    // changePriceRange(val) {
    //   this.priceValueRange = val
    //   // 规格是否选中状态判断 ，有价格区间 说明无规则选中，无则代表有规则选中
    //   if (val) {
    //     this.$emit('attrSelectChanged', false)
    //   } else {
    //     this.$emit('attrSelectChanged', true)
    //   }
    // },
    changePriceValue(val) {
      this.priceValue = val
    },
    manageSetPrice(type) {
      if (type === 'spu') {
        this.showSpuFlag = false
      } else {
        this.showInfoFlag = false
      }
      this.$emit('manageSetPrice')
    },
    /**
     * 跳转到会员中心
     */
    goVipCenter() {
      // 埋点
      this.$util.trackWithVariable({
        platformConf: {
          [PlatformTypes.UPLUS]: {
            id: 'MB31480',
            param: ['sku_code', 'md_code', 'store_code', 'product_id', 'product_name']
          },
        },
      }, {
        sku_code: this.products?.sku || '',
        product_id: this.productId || '',
        product_name: this.products?.productFullName || '',
        store_code: this.storeInfo?.storeCode || '',
        md_code: this?.storeInfo?.mdCode || '',
      }).then(res => {
        console.log('report res', res)
      })

      const url = this.$util.isProdOrPreEnv() ? "https://hzy.haier.com/cn/vipcode/noPayingMember" : "https://hzytest.haier.com/cn/vipcode/noPayingMember"
      this.$store.dispatch('goPageByType', {
        type: 5,
        params: url
      }).then(res => {
        
      })
    },
    /**
     * 跳转到店铺详情页
     */
    goShopDetail() {
      this.$emit('goShopDetail')
    },
    /**
     * 更改凑单说明弹窗显示状态
     */
    setDisLegendFlag(flag) {
      if(!this.disLegendPositionFlag) {
        this.disLegendPositionFlag = true
        this.setDisLegendPosition()
      }
      this.disLegendFlag = !!flag
    },
    /**
     * 设置凑单气泡位置
     */
    setDisLegendPosition() {
      if(document.getElementById('disLegend')) {
        let pageInfo = this.getBrowserInterfaceSize()
        let elementBtn = document.getElementById('disLegend').getBoundingClientRect()
        let elementContainer = document.getElementById('voucher-center').getBoundingClientRect()
        let ratio = (elementBtn.width / 1.96 * 2).toFixed(2)
        this.disLegendTop = ((elementBtn.bottom-elementContainer.top) / ratio + 0.24).toFixed(2)
        this.disLegendLeft = ((elementBtn.left-elementContainer.left) / ratio - 0.12).toFixed(2)
        let right = Number((elementContainer.width / ratio - this.disLegendLeft - 4.34).toFixed(2))
        if(right < 0) {
          this.disLegendLeft = Number(this.disLegendLeft) + right
          this.disLegendTopLeft = Number(this.disLegendTopLeft) - right
        }
        if(this.disLegendLeft < 0.24) {
          this.disLegendTopLeft = Number(this.disLegendTopLeft) - (0.24 - this.disLegendLeft)
          this.disLegendLeft = 0.24
        }
      }
    },
    /**
     * 获取浏览器窗口实际宽高
    */
    getBrowserInterfaceSize() {
      var pageWidth = window.innerWidth;
      var pageHeight = window.innerHeight;

      if (typeof pageWidth !== 'number') {
        // 在标准模式下面
        if (document.compatMode === 'CSS1Compat') {
          pageWidth = document.documentElement.clientWidth;
          pageHeight = document.documentElement.clientHeight;
        } else {
          pageWidth = document.body.clientWidth;
          pageHeight = window.body.clientHeight;
        }
      }

      return {
        pageWidth: pageWidth,
        pageHeight: pageHeight
      }
    },
  },
  watch: {
    ioucInfo: function (val) {
      this.showIoucAction = true
    },
    // showIoucAction: function(val) {
    //   if (val) {
    //     this.$modalHelper.afterOpen()
    //   } else {
    //     this.$modalHelper.beforeClose()
    //   }
    // },
    showVoucherFlag (val) {
      this.$parent.scrollDisable = val
    },
    showRightsFlag(val) {
      this.$parent.scrollDisable = val
    },
    sgStockInfo: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        this.newStockNum = newVal.stockNum;
        // this.$set(this.sgStockInfo, 'stockNum', newVal.stockNum)
      }
    }
  },
}
</script>
<style lang="scss" scoped>
:deep(.address-list){
  > div{
    padding-bottom: 1.2rem !important;
    height: calc(5rem - env(safe-area-inset-bottom));
    height: calc(5rem - constant(safe-area-inset-bottom));
  }
}
.bold{
  font-weight:bold;
}
.commission-w{
  padding-top: 0.22rem;
  background-color: #fff;
  padding-left: 0.24rem;
}
.van-action-sheet__header {
  text-align: left;
  padding-left: 0.24rem;
}
.van-image.van-icon__image {
  width: 0.24rem;
  height: 0.24rem;
}
.van-skeleton {
  padding: 0;
}
.van-stepper__input {
  margin: 0;
  color: #333;
  border: 1px solid #e4e4e4;
  background-color: #fff;
}
.van-stepper__minus {
  border: 1px solid #e4e4e4;
  border-right: none;
  background-color: #fff;
}
.van-stepper__plus {
  border: 1px solid #e4e4e4;
  border-left: none;
  background-color: #fff;
}
.close-icon__bill :deep(.van-action-sheet__close img) {
  position: absolute;
  width: 0.4rem;
  height: 0.4rem;
  /* padding: 0.1rem; */
  right: 0.24rem;
  top: 0.16rem;
}
.close-icon__bill :deep(.van-action-sheet__header) {
  text-align: center;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
  position: relative;
}
.close-icon__bill :deep(.iouc-table) {
  display: flex;
  flex-wrap: wrap;
}
.close-icon__bill :deep(.iouc-cell) {
  width: 3.42rem;
  padding: 0.24rem 0 0.24rem 0.24rem !important;
  box-sizing: border-box;
  margin-bottom: 0.16rem;
  background: #f9f9f9;
  border-radius: 0.16rem;
  /* text-align: center; */
}
.close-icon__bill :deep(.iouc-cell:nth-of-type(odd)) {
  margin-right: 0.14rem;
}
.close-icon__bill :deep(.iouc-cell *) {
  font-size: 0.24rem;
  color: rgba(51, 51, 51, 1);
}
</style>
<style lang="scss" scoped>
.van-popup{
  right: 0;
  @include max-width;
}
.goods {
  background-color: #f5f5f5;
  padding: 0 12px 0 12px;
  position: relative;
}

.goods .sales-wrap,.order-wrap,.other-feature{
  background-color: #fff;
  border-radius: 0.24rem;
  overflow: hidden;
  margin-top: 0.24rem;
}

//--------------------- 块内元素divider start
.goods .sales-wrap > div{
  position: relative;
}
.goods .sales-wrap > div::after{
  content:'';
  width:289px;
  height: 1px;
  background-color: #eee;
  position: absolute;
  bottom:-2px;
  right: 12px;
}
.goods .order-wrap > div:last-child::after{
  display: none;
}
.goods .sales-wrap > div:last-child::after{
  display: none;
}

.goods .order-wrap > div{
  position: relative;
}
.goods .order-wrap > div::after{
  content:'';
  width: 289px;
  height: 1px;
  background-color: #eee;
  position: absolute;
  bottom:0;
  right:12px;
}
.goods .order-wrap > div:last-child::after{
  display: none;
}
.goods .order-wrap > div:last-child::after{
  display: none;
}
.goods .order-wrap > div:last-child::after{
  display: none;
}
.goods .other-feature > div{
  position: relative;
}
.goods .other-feature > div::after{
  content:'';
  width:6.34rem;
  height: 1px;
  background-color: #eee;
  position: absolute;
  bottom:0;
  right:0;
}
.goods .other-feature > div:last-child::after{
  display: none;
}
//--------------------- 块内元素divider end

.goods .price-wrap{
  // background-color: #fff;
  flex-direction: row;
}
.goods > div{
  background-color: #fff;
  @include synShadow;
}
.basic-info-wrap  {
  // border-radius: 8px;
  padding: 0 0.32rem;
  // background-color: #fff !important;
  // margin-top: 0.24rem;
  margin-bottom: 0.24rem;
  position: relative;
  // overflow: hidden;
  left: -0.24rem;
  width: 375px;
  box-sizing: border-box;
  // top: -16px;
  .product-tips {
    color: $themeSynMain;
    padding-left: 12px;
    padding-top: 12px;
    font-size: 12px;
  }
  background: 
       linear-gradient(180deg, #FFFFFF 0%, #F5F5F5 100%) no-repeat;
  background-size: 100% 48px; /* 渐变区域高度48px */
  background-position: bottom; /* 渐变固定在底部 */
  background-color: #ffffff; /* 主背景色 */

}

// .basic-info-wrap::after {
//     content: "";
//     position: absolute;
//     bottom: 0; /* 从底部开始 */
//     left: 0;
//     width: 100%;
//     height: 48px; /* 高度固定为48px */
//     background:  linear-gradient(180deg, #FFFFFF 0%, #F5F5F5 100%);
//     pointer-events: none; /* 避免伪元素影响鼠标事件 */
//     // z-index: -1;
// }

.goods .price-wrap > div {
  // height: .92rem;
  display: flex;
  align-items: center;
}
.goods .price-wrap > .activity{
  background-image: linear-gradient(102deg, #FF175F 0%, #FF4C4C 100%);
  height: 1.12rem;
  margin-bottom: -12px;
  position: relative;
  left: -16px;
  width: 375px;
  height: 60px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  &::after{
    content: "";
    position: absolute;
    bottom: -1px; /* 从底部开始 */
    left: 0;
    width: 100%;
    height: 16px;
    background:  #fff;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    pointer-events: none; /* 避免伪元素影响鼠标事件 */
    // z-index: -1;
  }
}

// 预热
.goods .price-wrap > .activity.prehot{
  background: linear-gradient(to right,#FF7B28, #FFB818);
}

// 开始
.goods .price-wrap > .activity.salling{
  background-image: linear-gradient(102deg, #B54DFF 0%, #6018FF 100%);
}
.goods .price-wrap > .activity.yuyue{
  background: linear-gradient(90deg,#00a8cc 21%, #00e0ae 95%);
}
.goods .price-wrap > .activity.xsqg{
  background-image: linear-gradient(102deg, #FF175F 0%, #FF4C4C 100%);
}

.goods .price-wrap .activity .left {
  // padding-left: 0.14rem;
  // flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  img {
      width: 72px;
      height: 20px;
    }
  .icon {
    position: relative;
    top: -8px;
    .pintuan {
      background-color: #fff;
      color: #ED2856;
      font-size: 10px;
      padding: 2px 4px;
      border-radius: 4px;
      margin-left: 6px;
    }
  }
  
}
.goods .activity{
  padding: 0 0.24rem;
}
.goods .price-wrap .exclusive-price-label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: linear-gradient(90deg, #FFF4F0 0%, #FFFCF7 57.33%, #FFF 100%);
  border-radius: 0.16rem;
  position: relative;
  left: 0.24rem;
  padding-bottom: 0.24rem;
  .exclusive-countdown {
    display: flex;
    padding-left: 1.28rem;
    .countdown-img {
        width:3.92rem;
        height:0.76rem; 
        position: absolute;
        top: 0;
        left: -0.12rem;
        z-index: 10;
    }
    .title {
      z-index: 11;
      font-size: 0.22rem;
      font-weight: 500;
      color: #fff;
      position: relative;
      top: 0.2rem;
    }
    ._count{
      margin-left: 0.18rem;
      z-index: 11;
      position: relative;
      top: 0.12rem;
    }
    ._count span{
      font-size: 0.2rem;
      font-family: 'PingFangSC, PingFangSC-Regular';
      font-weight: 700;
      color: #ffffff;
      // line-height: 0.28rem;
    }
    ._count span.block{
      background-color: #BF4527;
      padding: 0.02rem 0.04rem;
      border-radius: 0.04rem;
    }
    ._count span.colon{
      color: #fff;
      padding: 0 0.04rem;
    }
  }
  
  .prices {
    display: flex;
    margin-top: 0.38rem;
    align-items: center;
    .current-price {
      font-size: 0.56rem;
      font-weight: 700 !important;
    }
    .float-number {
      font-size: 12px !important;
      font-weight: 700 !important;
    }
    .origin-price {
      font-size: 0.24rem;
      color: #999;
      position: relative;
      top: 0.10rem;
      left: 0.16rem;
      text-decoration: line-through;
    }
  }
}
.exclusive-price{
  font-family: 'PingFangSC, PingFangSC-Regular';
  font-weight: 400 !important;
  line-height: 0.24rem !important;
  text-align: center;
  color: #ED2856;
  font-size: 0.24rem !important;
  padding: 0.06rem 0.08rem;
  border: 0.02rem solid #ED2856;
  border-radius: 0.08rem;
  margin-left: 0.14rem;
}
.current-price .coupon-price {
  background: #ED2856;
  border-radius: 0.24rem;
  border-bottom-left-radius: 0.04rem;
  color: white;
  font-size: 0.24rem;
  font-weight: 700;
  height: 0.48rem;
  line-height: 0.48rem;
  padding: 0 0.18rem;
  position: relative;
  top: -0.06rem;
  margin-left: 0.16rem;
}
.current-price .float-number{
  font-size: 12px !important;
  line-height: 24px !important;
  .min-tips{
    padding-left: .04rem;
    font-size: .38rem !important;
    line-height: .38rem !important;
  }
}
.current-price .discount-suffix{
  font-size: 20px!important;
  line-height: 20px!important;
  font-weight: 600!important;
  margin-left: 5px;
  position: relative;
  top: -2px;
}
.current-price .pre-order{
  font-size: 0.28rem !important;
  line-height: 0.28rem !important;
  font-weight: 500;
  margin-left: 0.1rem;
  position: relative;
  top:-0.02rem;
}
/* .goods .price-wrap .activity .left { */
  // background: $themeSynRed;
/* } */

.goods .price-wrap .current-price {
  display: flex;
  align-items: center;
  color: $themeSynRed;
  font-weight: 700;
  position: relative;
  // font-family: DINAlternate, DINAlternate-Bold; 
  font-family: PingFangSC-Medium;
  font-size: 0.36rem;
  line-height: 0.66rem;
  // margin-left: 0.24rem;
}
.goods .price-wrap .bottom-price {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  // font-family: DINAlternate, DINAlternate-Bold;
  font-family: PingFangSC-Medium;
  transform: translateY(-2px) translateX(2px);
  .divide{
    width: 0.02rem;
    height: 0.24rem;
    background-color: #fff;
    margin:0 0.16rem;
  }
  .sale-num{
    font-size: 0.24rem;
    line-height: 0.32rem;
    color:#fff;
  }
}
.goods .price-wrap .activity .current-price{
  margin-left: 0;
}
.goods .price-wrap .activity .activity-icon{
  width:0.8rem;
  height: 0.8rem;
  padding-right: 0.14rem;
}
.goods .price-wrap .activity .current-price {
  color: rgba(255, 255, 255, 1);
}

.goods .price-wrap .current-price .current {
  // font-size: 0.28rem;
  display: flex;
  // align-items: center;
  align-items: baseline;
}

.goods .price-wrap .current-price .current span {
  font-size: 24px;
  line-height: 24px;
  // transform: translateY(-1px) translateX(-2px);
  font-weight: normal;
}

.goods .price-wrap .original-price {
  font-size: 0.24rem;
  color: #888;
  text-decoration: line-through;
  position: relative;
  top: 0.04rem;
  .min-tips{
    padding-left: .04rem;
  }
}
.internal-origin.original-price{
  margin-left: .24rem;
}
.goods .price-wrap .original-price.none {
  text-decoration: none;
}

.goods .price-wrap .activity .original-price {
  color: #fff;
}

.goods .price-wrap .activity .right {
  // width: 2.58rem;

  height: 1.12rem;
  position: relative;
  padding-right: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  top: -8px;
  // flex: 1;

}
.goods .price-wrap .normal {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.goods .price-wrap .normal .left {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  .activity-icon{
    margin-right: 4px;
  }
}
.goods .price-wrap .normal .right {
  // width: 2.58rem;
  // background-color: #fff4f6;
  // height: 1.12rem;
  position: relative;
  font-size: 0.24rem;
  line-height: 0.34rem;
  text-align: right;
  color:#888;
}

.goods .price-wrap .right .activity-tips {
  text-align: center;
  font-size: 0.24rem;
  color: white;
  line-height: 0.34rem;
  margin-top: 0.14rem;
  margin-bottom: 0.1rem;
  margin-right: 5px;
}
.notice{
  background: #F6F0EA;
  border-radius: 6px;
  padding: 10px 8px;
  margin-top: 12px;
  .notice-content {
    display: -webkit-box; /* 必须加，启用弹性盒子模型 */
    -webkit-box-orient: vertical; /* 设置文本垂直排列 */
    text-overflow: ellipsis; /* 显示省略号 */
    -webkit-line-clamp: 3; /* 限制最多显示三行 */
    // max-height: calc(1.5em * 3); /* 计算三行的高度 */
    font-size: 12px;
    color: #593618;
    letter-spacing: 0;
    // text-align: justify;
    line-height: 17px;
    font-weight: 400;
      overflow: hidden; /* 超出部分隐藏 */
  }

}
.notice-expand .notice-content{
    white-space: nowrap;
}
.goods .activity-wrap {
  font-size: 0.24rem;
  font-weight: 400;
  line-height: 0.36rem;
}
.goods .activity-wrap .activite-text{
    font-size: 13px;
    color: #ED2856;
    letter-spacing: 0;
    line-height: 16px;
    font-weight: 500;
    margin-right: 5px;
}

.goods .activity-wrap .content {
  word-break: break-all;
  color:#333;
  position: relative;
  font-size: 13px;
  // top: -0.04rem;
}
.goods .activity-preview {
  padding: 0.1rem 0.24rem 0 0.24rem;
  display: flex;
}
.goods .activity-preview .title {
  flex: 0 0 auto;
  width: 1.14rem;
  height: 0.44rem;
  background: #ffe6e2;
  border-radius: 0.12rem 0 0 0.12rem;
}
.goods .activity-preview .title img {
  width: 0.9rem;
  height: 0.22rem;
  margin: 0.12rem 0 0 0.12rem;
}
.goods .activity-preview .content {
  flex: 1;
  padding-left: 0.17rem;
  font-size: 0.24rem;
  color: $themeSynRed;
  // line-height: 0.44rem;
  background: #fff4f1;
  border-radius: 0 0.12rem 0.12rem 0;
  display: flex;
  align-items: center;
  padding-top: 1px;
  // height: .44rem;
}


.goods .detail-wrap .detail-title {
  display: flex;
  padding-top: .16rem;
  .text{
    // -webkit-user-select: text;
    font-size: 15px;
    line-height: 22px;
  }
}

.goods .detail-wrap .detail-title .title {
  // flex: 1;
  font-size: 0.3rem;
  font-weight: 500;
  color: rgba(17,17,17,0.93);
  line-height: 0.44rem;
  font-family: PingFangSC-Medium;
}

.goods .detail-wrap .detail-title .title .zy-tag {
  background-image: linear-gradient(90deg, #5A94FF 0%, #873AFC 100%);
  border-radius: 2px;
  font-size: 11px;
  color: #FFFFFF;
  letter-spacing: 0;
  line-height: 12px;
  font-weight: 500;
  width: 26px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  display: inline-block;
  margin-right: 4px;
  position: relative;
  top: -1px;
}

.goods .detail-wrap .detail-title .title .text {
  display: inline;
  font-weight: normal;
  word-break: break-all;
}
.goods .detail-wrap .detail-title .title-right{
  font-size: .28rem;
  color: #999999;
  line-height: .44rem;
  margin-left: 8px;
}
.goods .detail-wrap .detail-desc {
  font-size: 0.26rem;
  font-weight: 400;
  color: #999;
  line-height: 0.4rem;
  margin-top: 0.08rem;
  word-break: break-all;
}

.goods .detail-wrap .detail-remark {
  font-size: 0.24rem;
  font-weight: 400;
  color: #999;
  line-height: 0.34rem;
  margin-top: 0.28rem;
}
.goods .detail-wrap .item-brandlist{
  margin-top: 4px;
  margin-bottom: .15rem;
  position: relative;
  display: inline-flex;
  max-width: 100%;
  box-sizing: border-box;
  height: 24px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 6px;
  padding-right: 8px;
  font-family: "PingFangSC", Helvetica, Arial, sans-serif;
  color: #BA5602;
  font-size: .2rem;
  background-image: linear-gradient(269deg, rgba(255,196,153,0.20) 0%, rgba(255,105,13,0.20) 100%);
  border-radius: 4px;
  overflow: hidden;
  transform: translateZ(0);
  will-change: auto;
  width: 343px;
  font-size: 13px;
  font-weight: bold;
  span{
    width: .44rem;
    height: .36rem;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAA2CAYAAABz508/AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAQqADAAQAAAABAAAANgAAAADk/8cYAAAXDElEQVRoBbWbeZBdxXXGz73vzaJZtI+WQQJtLIIAChbEgKFASVgDAkywi5CUQ0JBsIPjxMbmH4wdV6qwq2xwiGNXsGNiEhFCDLKDZAojATYGm1USm0BikYT2daQZzcybd29+37m339z3ZiRju2jcc3s5ffqcr0+fPt1PjuwwKV122wwbjBZbbBdbms61KO62KOrwIVFk1CnqqxZ9VTjUV13QiyalHIs2r1OqjXO+o/ERST6fk2ueUcarz1N0AFE2M9d6CB82Ky+NPvzRTaG38asZR6R06W3dVq18CUZ/CZOS9R8w6+sxGzxoNjQ0TJ+ikSsmzSQY35Sv2qWtyq61vqGY04omL2b0Gp/T+FjKtboG5xWNqSXxUDvJF8ELXrXmVrPOCWZdR5pNniGCKiz+3ZrGfDE6ZfHmjGj4b85luCH931suNUvuRbhO27nRbAf54P5MaAmYJBlxyjeRIJJM32JdTdRd2ZymVs7H+9hGmlDPx2umOr7w0jifT+Wc3uUqzNOo1YRpZgv+yOxD55uVmvZbKb4mOvWqH4l9SHVD0gc+e5Ml0Tesvye2Da+aVfpHKh6EqClWEGBU5YPiowgdFKjxzGmKANcUp8/LiF6bp1geRQ5pSbMbk8pju8wW32R2xLyEbfWZ6LSPfVPNSjUg0vv//lIGPWj7d8W2lW2VVocRD6sehHJBc6GLgLhitCuFdrcgCam2wpiaZdFRoxFdnp2XyhrjDIcXJVhCoA18RVbjlc8XZFafUqnJ7JJPmh17WmKl8uXBMhyIdMnN3Zb2v26DfZ22dZ1ZNfcDgWlRcTHzdr5BgJpAQZFc+KDECLocrMA38BSfIphhHn3DHMV+b8vnCrIGOn3D+OL8misGjD+71az76P3WPOY4+Qy5YSbp/ZIlQ522G38gaEoliOkqfkvlrK620B6LLs+1toZxgU/o92/OP/QVv15mrrpvPmcYK1l8XuaKc9pyQZYgUznvUz2MFd+Ehf7Rndr6nTaA7qQovfdvcamD73AqlKxnR4Z8QN0XKKyevkKZLLRVDqiHejBD1Ws5X7FgHWHlNLuvtPpFL5Z5udaX8wnyFNtVFn1RnpoFMC7MU5Mj51VrZ/zZV5ktvKhqpWhW2ZKDi8GjZAOcDEJNA0VcAjkvy0RoC8ekH5FiKqHpCu1ezhUJfa4A48VHMYP4+jFH3edgvkT8SS4w5aBYKR/ngtOvmEF8a/PBQ0dnTR7qgUa8ivNQhbgwP1XxffkJnSQlS+LFAJFcbAmOUZPIbDTIzYd6YOhC5nXxFJMQI7gi1KsMnHas2fU/EMVwenqJ2bKvZgqKr5KDoLk0GcqY+PE561qOuYsokFT3ROE7tO/fRRvABYW8nz8uC1+XUY0BQJXzuviIzoM42gS2gO6B565NZpNmXFwGgLm+Z7SPfBKIxFSERVOvrRwMXXgxpKxh6isnljIRpbqUsmKRBPCoUGPo9tXiq/E+gD9Vxk88wqKjFtSNVyVtamZ4Lh8s8kH5/IxVm1shhQCIW4r4C3B9NZHmJ6vPy7QrTpo4fa4sghMDi5ADcsVEDIEIfWxeD6ZaNMfaJKnPlRjbjZHFRI//F8sa2ieZXXX7cLdbhGaSYKQJuKvR0l99BxErGWY5aUZGZfNasyW3UIW/byuKNVCkAMkXUXqQY+mmNr7SScFitdqNRVSzu4MEDaiF1ZOgvmo5ml6nTYI7WFlR2yK1IRZ7aAQQCSBHkawFiMqs7FG/LzHqUi5uXVuxMpqVhP4UWSPJLtlKZC2UZ5Ulp9qh5jN8BVBZdHwVNKZJBxaBNch0i44yFgXZmWgAZWcqFNXFN1hDElvaMR48+y0dM5bOhoRZJx0ToefsRt5Gi2mg/s2riJewsrErz/Bc9OwrOcVS1kLZ9cj1UYf0U0If+QiIEc8Vo8ORyhWveWQxYYBbDF+ZmsYBgk2cYtEnvu8KjqZkeeHHOaLIpMq/XmHp499CniqZ8Z6wJhcQq8GmvK+mjXwOK+5ZZdcqH5fVoz1bXPwUWSKBoSS5xCPlW1tAyZzrFb7Sz/UNQAgxWYQjRKejJ14CgLr6fSvALFiJ77uh7ASD4v2kat8uq/70doxwAHYVa73saxZ3TnX1tLmi6qAduOdqpmRe6cTUpcnzrG3x7XUgDK1dYZWn7kaqspWjZnILhJJRg8hsxTqlc2UzfPMFCBYiwdkVmUX4YIGhyYUSZUdN35xpsJSaN6aLcQlR2miWIP6NSStesyo643Hd1nT8BXVk5SnHWbLzLddHMjTPv8Caf++SOprKG49nfCSnFklZZVm2L1y+YNK8trgCiSQrEQjB+cstoGPmI0SgU0MDxSig5WBkzd4npgJGE+PFpVjS855V7v6oVQd7rXzKVdby4WvpH06V1x6xgUdvx+B4H8Ai4hIOE6G1+kNvrhwBRPOx59nQvnu1NIiSWNPRi4aZ5aUqFlGKW3FtZTL8DP/jICCXy4+c4XQQ+NLLF5ey+sOiquxgySKktFAJnlcdAS0RltvMzrzB7I0VZhtfZJwQ1HicLMzTZNCq2161oYN7remsG3NRhz/xpFlW3bLGrKndWs7+lJUXXu2dfmTqJtiQWi661VrO/XROwxSdU+oo5E/ab1iK8oJKGVG+frFFQ5JHFYTzL3+OPt3s5IvNHvqK+eOSOoKFiE66K7lFSCElWYRWWwSeVaZ9/EyzjslmJ11G8LHObIDXKvWDoSK9aIgV0SqjVHnmyKMx7jrGIuKHqMoxOma8ReO7NVuughfr/kQtnObKJOnTmCJWM5qATMXk1kxDrpcr2DrO7CN/jl7NZlNns4i8r0g/7WMB4I4SC9IstGtJqaCYLMJvaHx15ou5xxaipa0JhyRFReN0gEBcEPMkVmput9L4GRYLtIYkwZtmn87Nl/Hi9wEkWZeiWpdLskq+Y87MAC3nVleQO8hf08+dpaMDkyBkbS9JYtr7doKTgII5Ht6/Ao+4gFdAPqnFY3A2rPyhUmnORyzZ+BJsZEn1af8PrrFkECtjrph9HnGt1t5X3Y9TThc5ZB2rahvzB9da84m8JhZSwinBSLpzPWT+hOtZtDxktndLpp8fr/SFSDPIgz75qQHXuq0BQ1eeL0edbX3ZbAbWIHSFrDPKwdDcCGvdJxZEqy+W8fwDT95Fo5SpT5XXH7V0oMeVaJp1hpWOXIhKMPXMuYSQlV/dwyV5rw+szju3ngE1hfYCL3K7Z6wiTFmg5H3tKR6ciR4lt3RSLsZH7jjdWebCySKg8STiMUSDR50BCDi6dSt472Nv71oPE5kek+kY0qbMnWbcfVI+eOQnHs9lavoJlvTutuqutxnDuDxFLEDM1pLizSdcYq3nZI4y9Os7tPYxfNEgOhBw9cFjJ77KkyBjd6OYQu3saM4V3oxPmDzL7LkfogcXudmnmb3Eq/6eTcyfKxosg12RWUTYXyESk6ATYTJjIflDZu8+bfbCPSwooAlZIaYt5Vhgwi1tVpoJ7WFS6bjzbOCRf7SDT9xhSaXPhYnLLTwhtlncOgEdYh6bWMVRUqm5w0ot44l7Klb52besf+XX0WUIK8BBN3VYM31WFhBy4Fok5Nu4yuw9LHnhFWYnKlahTc6+h20iHCS/FtQtohZH0OMWIQqSANn9lgoQUp6F45F5rX88AyIw8csWZEeeyqmhfX3oFEPTeuU/W2nOWRDl87Ce2Srm40Y5TtXTduNyhmgM2YeG8eqNrEqUGT1zXyZr0EP0J/8J7xt5MAaItglg5OvU5wDkfGqRpRqLe0iEVX7M2fALQDhbs5nNPcdsy2rOY/aq6LUtctOKZgPUIVLCCsRjp2dAl1statE2+M1S1DTmsAOiJoI1yS8lZaaSv31CZg1hgV54iKN/f76QAoCsBVViB2THp9oDIzETqsobcDTb8BFKevmddgJf+n17lAgj2BYcn/ERp2Q0o/wdWP2gDb3zTCZczRJGIfwdm3R81o5QyT4X/9ZMMCgg1rGgLwKEZHcfl+voOrOowxaBFApR/T4PKtoa7EuXe+3/me3baDZ9ATYKyhosxGURuIy0e0FtW1R3v2Ml+Za6lFrv0n+w9j/9tvX//C6LX7qf4fp9pcnarryrjjI5sMN6H/wMCwRjJpffkPBxTMCm12oZInP7pQwR9A6hvpjjUdvdF09jZLHjOOp3vWP26mPkR3H2UxgLXz1QK7k1qyB9g4+o2xooKEVP/osMDO4HtvUFs1X/6QMcVTlTjipXqG2yuHk6+Pg3rOOKO0M1+wJwsvNNG3jmbqtueJY3HBRRXIBijUCkg302uObBbH5pzSrrSIwAP9JCZUjQH1iXWZcxVm4Zx8nTOQyE5H/2vzN5j/9jfsMAcEW0nFr2/b8GBPr95MsZORB+/MFY5iQGmkyEW57j2DkHK5hkNgdm3aeavb6UR1R5XcyQ2CHFJLJAh7eGt35ulQ2/yiQs/NVbo47H6uvL+bY5eMZRqKi0McXtE6398jsyS3ClAwUy8b8AgFpVrW552ZJXlsGL4M5/38BqZP5So2uu2aKbckvQCNJqjk/fHhBIV2UZQQaEVpcGmXy4kOg+v30VQQl7rJvzV6l1PPeNq83W/hiTe8MZZI8oGo8PXfm1TBivDf/RHaTUNt6PRgmb4qBSTqBUADekqKXTWk+/rqH10NWhVx62oXU/w321EeG2ZFYjQGbis/7w79CpaXjw8w+YrVmWLbha5SgdCJUJyISG4yuLcOcBIHIwQm7LLzkyGcwN05Mc5vzLCbWn0Y9V5KtUWfuIVTevQtmRq6xjVUCUO7uszL5tIpc7uqw0aVbG83f46yC3drql6eLnkWTXHLMLvpA5SoHCdd8eu4OtwvEq/aRbcJiq1ywiHCEiCOaitvBuuXc9JrWJKI0TY+rJWAlOVFvlhe9mDNkig7/4F+4bHRyNWFBjQpiY22TcjlXoTUKOkJ/iolEi0er2tZbsZS4E1WWNAhlrVWnMBCsdwfwNSWBE/tzPIsnJn3kdylI+gG97mUV89Sccm70+57AVaDvkW0P8/NSQYD4nfxydsG9yQqGXEoxsfzHLPIT4lpEpMmH17Se4fB30VffjqlFQjYdW/iEijiCs5CVt0ErHAGZD2r/kWktxrH6t17gABEKXZp1uHZ+4v26Eh9wS21eWhZRVPP09nCIg9O/PaKWwrFuASr+w/dXuRiA9Q4gdtkcgDoCIlex//FyUwSvLsQ72MBFHEDSRYghdyjhWU4KatHmUwEe8ZG2yAgSWX4mmnmAxT3LFVNn4nCXbXsvCbI1RVpKcjJFzHpFc7uye4WDoSNcW13OB3lB00uzfzvZ+ii3CeNGLrb4OUA42dbxX2muVwXZ66ufxFaFNIBy5aES39e2wiGM1VvSJb0j7sQ5FeI1JOulhVY4SIdO2iRaf8ak6Kl3P+zl6S/wckFkOcYNbouTlqK1wyrSMrRvjFRRwPyXfNP98s7nn8CPRzJF0svq3kTPEDvoKCAdD5WovT3VDO6y/DyBCoiOAImz2vYXTpHsKKMv0lGiP2rrwFedZNOVE9uJ9luzZiPDszRFJTlXIM2jcTItOvgalsK5C6l/xVUs2PG1l/kVLiZclhcweN8gS+LcaCUCUF1xZGJEVE1kmp0904ZfxYSxYY5JvWLOUCBmnLxlC7CBrC0BoTGo7sNlkte3aPCu3GW9VX6Zt/t25mkvYq5zJs8lH8fLDUVrKjytMNu46nn9igVBVTHHUxMS6s3DiZL9hDhP1P/sfNkDEWR43xUq8T5Y5YeRLovmXWHTcRRkhp1XmPIfHqZTu24TvOI0gBoV5PHbzl/L7NvNT4EsA8Dx93JmKsYMWRH7CgdAWESjV1WWu1iutZ+eldmAPFxUUpH0YFJWVaNQ/rtj7Jvd5stPQrL0mh6OfzfzUCR0+KPtDk/uFmWfUgaCHlr7lX7TKqvutxH4udUyyEgFVzHHowRFXcj8SC6yKxeTATt4pfmpx2zhL33sR8Fro1mSikrLIpW9wlMFJ1k5EurVFKqKzlfxG0ryEAYO2DgRrejg3+guMQ2eNRt1YgJyTJvOsLVCftP/950CBRkoBrf+X37V9d55hlTUPoPwErIEtQZxRahuLA25hkXSfAPhDpOqON6zvf67300dHpT8BhBhB/si3QUEmyab+ECtp0VR2cDxIWlKO/untbennp91rbzx/rc05CdOfyPTSVmCQa4oXwPE+SRnaVCZhNcn+bTTrp7v80sQzXDLYbwkXt8orS22ArVDt2ezWEXdOIria7IGWAMmu24AAWMn6J6yyaRVL1IuPoK7MXSHZud55lTmpSnr5IoaoBYC+cAisGEgrL/HC6eP1XC8BMETG90Bwb3T9km2uZnrb3Cl2oPc1mzh1oi36uJ/7w2BIw5ByRl6lrH3GkZUO8cDK2V3Z/q4Nbltv1b1bwYIXJFa4zL6PWzugGbAq/2g11T9aZTViHGa5c2K2JVAq5p1C/iPlHlLt28uPPNvJWynv4U2zD6viqQ5lwt1FkWrT2KlYFFtKbxx+KZM4koks2WSFXtU3tPHVKdKzD59S3Q1Q86O/eXC7AyG90pu7L4XghzZhSsnO/RgOMUSJucKBUoxD2QcCBGd00rvPhnZvssquDVZFCV2lBYD2vj+cyFoGAAHhYuIN7e2SABhDiMzDiy5OElZHZSIgegCCK3NycB9tA3QBgv7jqJQfcYvgV/YSgCqw8+3gykqZguJCIliH+hVP7NmJReiHlvjy6JNLuTzVq2TpZ6dfh1l92zomxXbW5fk2EVlIQkBIhKQ6k8oi8NZV/nmPVjJhFbUyHnChqDsyhHNlWLm4BSBkAdxKpVgWDMFLAgdevXvhs49tpdMAf6FpsRgp7UDyXhKzWPoJ0UGQSFJUSXw0QHUHIW8fZCvs2MIcQ6Ca3hDdtPzfnJ4/xbX1tvRz0y+Aw39hMhNs7gKzeeTxUzLGYZR/c1B8FbQ9WEnASPgXKG7+CCIn5mG1Vlt17VeA8Juijkg5LI8xAnsUQGlZhXik+BaPKPlnRa4U452neAhAbQeNL8YFQXnJ6IDw7ccS9+4iymSBongPWl8dffoRLiHDaQQQ6kpv655svfZlSgT/SYuN5crcPY88m3s+kZsUKCYHIwt+ZHoKgqS4Kx2UdafFdFpVleXJQ5t4hVX0FWQPY7n+UuXWkK+uFpYxLrQA8IX2P4wPNHzF4wA+YP9evuQBjve4pP31PetovzW6/sfsjfrkPOubhmvpF46cwDUW7xldxqxnw0i/7/FsdxR5TgYMe92T9qWSQMkk9Cpj+ZLVrp8NlIIVZLWRf+XMHBDGBH7FugAsKi4aHKrtIajr4RWqR1tT8sT9zPkk+SEb03FfdOPDdIyecslG7yy2YiVtdjA5lwvDRSz5Beg6x1d0LJebAErXjGylawPFXsA0JDX5zGF6KRzaCrRSMGRXLK87CIC1l4XdxXG9m9x3AJ7wi6K3UPwnyLnMJkxayeqD0K9PQZJfT9lAwSlzLKtyIVENwERnI3GL6UyfOgtgZmfgtHNRqimoqVQ5XAriFOi8mNf7uFpvfw+HR5by+sEpjgawsCeRYRn/TGJ59Pnn1h5uhkP1hZkP1f++2t1aequLEOZCBiiDBMKP7wKQuRkwXUcgNBFdDZmCsm4eeV2fIJWsYNdWlN9A3pTteXWW4rchWs7qL7cp5RXR9c+/r1WH8yFTmPKQBL9NR3pL93FEbgCSXJhZi7XoPcItpRtgps3i1qhrtaYPgORlrfo2FFfegfIcp6w4q25PggAvwOXl0W1rXv9t5DrcmA8EiOKE6demtttOW8S/AcyAMZvl/XKy+r8aKQsLAjLPAiI7Et/xVS/Hy62zbUX0udUEFB9c+sCBaBQ9vXn6fGKw8/kx6USsZR4okHWUpusAQHkN7waPRF9597XGsR9k/f8BlKpZYrqM77cAAAAASUVORK5CYII=) no-repeat;
    background-size: contain;
    transform: translateZ(0);
    will-change: auto;
    margin-right: 5px;
  }
  i{
    width: .24rem;
    height: .24rem;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJKADAAQAAAABAAAAJAAAAAAqDuP8AAABg0lEQVRYCe3XsU7DMBAA0Lu4GSJ+gE+oxMQAeyFlRBWoCSMfwMDC3pmFX2ACQiUkGEmkfgASSwHxCfABVYfSHr4KLyhpI/u8xcvJVux7vboXFaAZTQWaCgDQfV8VabjDUboeaHNgnqhHAjoEhPcwiuLO9eTL5pyyPUHZ4to1pPbyGYKt2XQ6Gp1ubK7dU/MBKxAhXujS/vyh2pIoK9DB3fwJEFMfKKs7ZKqfp+oIiDICaC3XED71neq43CknECOkUc4gaZQISBIlBpJCiYIkUOIgV5RVH+Kkq0Y3mz+U9KmizrvPS4UMNk9bV0SLczMPUO3G2ezFzMuilwpxoudU9YEWZyap/uTj/ePeq5lXRS8gxiDRjengGvOBKupiMpxXQcy6+FdWgdmLbyffJumqKApyxTBUDCSBEQNJYURAkhhnkDTGCeQDYw0qEtXT/zqG//pM7Z82J64aVo2RkC59YBhpByJ84826Z4x1BxapDJ9nPWgwCPKTcJuj9SHNxqYCnirwC7VV4wn3MVVbAAAAAElFTkSuQmCC) no-repeat;
    background-size: contain;
    transform: translateZ(0);
    will-change: auto;
    margin-left: auto;
  }
  strong{
    /* font-family: DINAlternate-Bold; */
    font-family: PingFangSC-Medium;
    margin: 0 2px;
    font-size: 13px;
    font-weight: 500;
    // transform: translateZ(0);
    will-change: auto;
    font-family: PingFangSC-Medium;
  }
  p{
    flex: 1;
    max-width: 100%; 
    font-size: 13px; 
    font-weight: bold;
    /* @include text-overflow(1); */
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    transform: translateZ(0);
    will-change: auto;
    font-family: "PingFangSC", Helvetica, Arial, sans-serif;
  }
}


.goods .voucher-wrap {
  // padding: 0.24rem;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 6px;
  // border-bottom: 1px solid #eee;
}

.goods .voucher-wrap .left {
  // width: 0.48rem;
  line-height: 22px;
  font-size: 0.28rem;
  color: #666;
  // font-weight: bold;
  white-space: nowrap;
}

.goods .voucher-wrap .center {
  // padding-left: 0.24rem;
  flex: 1;
}

.voucher-title{
  height: 22px;
  margin-bottom: .1rem;
  display: flex;
  align-items: center;
  font-size: .24rem;
  svg{
    margin-right: .12rem;
    width: .3rem;
    height: .3rem;
    color: #ff5252;
  }
  strong{
    font-weight: 500;
    color: $themeSynRed;
  }
}
.goods .voucher-wrap .voucher-container:first-child {
  margin-top: 0;
} 
.goods .voucher-wrap .voucher-container {
  width: 343px;
  position: relative;
  i { 
    position: absolute;
    right: 0;
  }
}
.goods .voucher-wrap .voucher-container {
  height: 22px;
  display: flex;
  margin-top: 5px;
  align-items: center;
  .voucher-tag {
    width: 31px;
    background: rgba(255,82,82,0.15);
    height: 14px;
    line-height: 14px;
    border-radius: 7px;
    color: #ff5252;
    font-size: .2rem;
    text-align: center;
    margin-right: 1px;
  }
  .voucher-blue-tag {
    color: #9C2302;
    background-color: #fff;
    font-size: 11px;
    font-weight: bold;

  }
  .voucher-rights {
    font-size: .2rem;
    line-height: 14px;
    max-width: 14em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 11px;
    color: #9C2302;
  }
  .voucher-desc {
    width: 10em;
    font-size: .2rem;
    line-height: 14px; 
    font-size: 11px;
    color: #9C2302;
  }
}
.goods .voucher-wrap .discount-container {
  min-height: .44rem;
  display: flex;
  align-items: center;
  .discount-tag {
    width: 0.62rem;
    // background: rgba(255,82,82,0.15);
    height: .28rem;
    line-height: .28rem;
    border-radius: .2rem;;
    color: #ED2856;
    font-size: .2rem;
    text-align: center;
    margin-right: 0.04rem;
    min-width: 0.62rem;
    margin-left: -2px;
    font-weight: bold;
    &::after{
      content: "";
      height: 8px;
      display: inline-block;
      width: 1px;
      position: relative;
      top: 1px;
      left: 3px;
      background: rgba(237,40,86,0.40);
    }
  }
  .discount-blue-tag {
    background: rgba(40,120,255,0.15);
    color: #2878FF;
  }
   .discount-rights {
    max-width: 17.8em;
    font-size: .2rem;
    color: #ED2856;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 0.28rem;
    padding-right: 0.16rem;
  }
  .discount-desc {
    width: 10em;
    font-size: .2rem;
    color: #333;
    line-height: .28rem;
  }
  .legend-icon {
    color: #ED2856;
    width: 0.2rem;
    height: 0.2rem;
  }
}

.goods .voucher-wrap .center ul {
  display: flex;
  align-items: center; 
  width: 323px;
  overflow: hidden;
  overflow-x: scroll;
}

.goods .voucher-wrap .center ul li {
  display: flex;
  align-items: center;
  margin-right: 3px;
  position: relative;
  height: 23px;
  overflow: hidden;
  border-radius: 2px;

}
.goods .voucher-wrap .center li.voucher-item {
    border: 1px solid #ED2856;
    box-sizing: border-box;
    flex-shrink: 0; /* 禁止元素压缩，宽度由内容决定 */
    transform: scale(0.8);
    transform-origin: bottom left;
    span { 
      font-weight: bold;
      height: 20px;
      line-height: 20px;
    }
}


.goods .voucher-wrap .center ul li:last-child {
  margin-right: 0;
}

// .goods .voucher-wrap .center ul li img {
//   width: 0.16rem;
// }
.goods .voucher-wrap .center ul li .coupon-line-bg {
  // width: 0.16rem;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 0;
  width: 100%;
  height: 0.4rem;
}

.goods .voucher-wrap .center ul li span {
  height: 0.4rem;
  line-height: 0.4rem;
  // background-color: $themeSynMain;
  font-size: 0.28rem;
  color:#ED2856;
  padding: 0 0.14rem;
  font-family: PingFangSC, PingFangSC-Regular;
}

.goods .voucher-wrap .right {
  width: 0.48rem;
  height: 0.48rem;
  position: relative;
}

.goods .voucher-wrap .right img {
  width: 0.44rem;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}


.goods .attr-wrap .center{
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  overflow-x: scroll;
  flex-direction: row;
  width: 275px;
  .attr {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    padding: 0 10px; /* 添加列的左右内边距 */
    white-space: nowrap;
  }
  
  .attr:first-child {
    padding-left: 0;
  }

  .attr::after {
    content: '';
    position: absolute;
    top: 5px;
    right: 0;
    height: 24px;
    width: 1px;
    background-color: #ddd;
  }

  .attr:last-child::after {
    content: none; /* 去除最后一列的分隔线 */
  }

  .attr-value {
    font-size: 13px;
    color: #111;
    margin-bottom: 4px;
  }

  .attr-name {
    font-size: 13px;
    color: #999;
  }
}
.goods .attr-wrap.two .center {
  height: 1.2rem;
}
.goods .attr-wrap.two .center::-webkit-scrollbar {
    display: none; /* 隐藏滚动条 */
}
.goods .attr-wrap .center.service ul::-webkit-scrollbar {
    display: none; /* 隐藏滚动条 */
}
.goods .attr-wrap .center.service {
  padding: 8px 0;
  // box-sizing: border-box;
  // max-height: 50px;
  overflow: hidden;
}
.goods .attr-wrap .center.service ul{
  // padding: 5px 0;
  box-sizing: border-box;
  max-height: .84rem;
  overflow: hidden;
  // padding: 10p 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style: none;
  // padding: 0;
  margin: 0;
  width: 100%; /* 修改为100%以适应父容器 */
  font-size: 13px;
  color: #111;
  li {
    // flex: 1 0 50%; /* 每行五个元素 */
    padding-right: 10px;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    .fangxin-icon{
      background-size: cover;
      height: 0.24rem;
      width: 0.24rem;
      display: inline-block;
      color: #111;
      position: relative;
      // transform: scale(0.7);
      top: 1px;
    }
    span{
      margin-left: 0.04rem;
      line-height: .42rem;
    }
  } 
}



.goods .attr-wrap,
.goods .number-wrap,
.goods .number-wrap1 {
  padding-left: 0.24rem;
  padding-right: 0.24rem;
  min-height: 1rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.goods .activity-wrap-container{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0.33rem 0.24rem;
  justify-content: first baseline;
}
.goods .number-wrap .left,
.goods .attr-wrap .left,
.goods .activity-wrap-container .left,
.goods .number-wrap1 .left {
  // width: 0.86rem;
  white-space: nowrap;
  margin-right: 0.24rem;
  font-size: 0.28rem;
  color: #666;
  // font-weight: bold;
  // width: 0.9rem;
}

.goods .number-wrap .center {
  width: calc(100% - 0.96rem);
  box-sizing: border-box;
  font-size: 0.28rem;
  color:#000000;
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.goods .number-wrap .center div:nth-child(1) {
  width: calc(100% - 0.65rem);
  color: #111;
}

.goods .number-wrap .center div:nth-child(2) {
  width: 0.65rem;
  text-align: center;
}

.goods .number-wrap .right {
  width: 0.48rem;
  height: 0.48rem;
  position: relative;
}

.goods .number-wrap1 .center {
  flex: 1;
  display: flex;
}

.goods .number-wrap1 .right {
  font-size: 0.28rem;
  color: #999999;
  line-height: 0.4rem;
}

.count-box {
  display: flex;
  align-items: center;
  border: 1px solid #e4e4e4;
  border-radius: 0.04rem;
  text-align: center;
  line-height: 0.5rem;
}

.count-box .btn {
  width: 0.8rem;
  height: 0.5rem;
  color: #979797;
  font-size: 0.4rem;
}

.count-box .count {
  width: 0.76rem;
  height: 0.5rem;
  color: #333;
  font-weight: bold;
  border-left: 1px solid #e4e4e4;
  border-right: 1px solid #e4e4e4;
  font-size: 0.24rem;
}

.goods .number-wrap .right img {
  width: 0.44rem;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.goods .address-wrap {
  padding: 0.22rem 0.24rem .22rem 0.24rem;
  min-height: 44px;
  box-sizing: border-box;
  // border-bottom: 1px solid #eee;
}

.goods .address-wrap .top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.goods .address-wrap .left {
  // width: 0.86rem;
  white-space: nowrap;
  font-size: 0.28rem;
  color: #666;
  // font-weight: bold;
  margin-right: 0.24rem;
}

.goods .address-wrap .center {
  width: calc(100% - 0.96rem);
  box-sizing: border-box;
  font-size: 0.26rem;
  color: #000;
  line-height: 0.4rem;
  font-weight: 400;
}

.goods .address-wrap .right {
  width: 0.48rem;
  height: 0.48rem;
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.goods .address-wrap .right img {
  // width: 0.1rem;
  // height: 0.16rem;
  width: 0.44rem;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.goods .address-wrap .bottom {
  padding-left: 0.8rem;
  // padding-right: 0.48rem;
  margin-top: 0.1em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.24rem;
  word-break: break-all;
}
.goods .address-wrap .bottom .bottom-left {
  display: flex;
  align-items: flex-start;
  font-weight: bold;
}
.goods .address-wrap .bottom .bottom-right {
  color: $themeSynMain;
  line-height: 0.4rem;
  font-weight: 400;
  // font-size: 0.28rem;
}
.goods .address-wrap .bottom .status {
  line-height: 0.34rem;
  font-size: 0.24rem;
  color: $themeSynMain;
  // padding-right: 0.2rem;
  font-weight: bold;
  white-space: nowrap;
}
.goods .address-wrap .time {
  // padding-left: 0.8rem;
  // margin-top: 0.1rem;
  padding-left: 4px;
  font-size: 0.24rem;
  color: #666;
  line-height: 0.34rem;
  font-weight: 400;
}
.goods .fare-wrap,
.goods .iouc-wrap {
  padding-left: 0.24rem;
  padding-right: 0.24rem;
  height: 1rem;
  display: flex;
  align-items: center;
  // border-bottom: 1px solid #eee;
}
.fare-wrap::after{
  display: none;
}
.goods .fare-wrap .left {
  // width: 0.48rem;
  font-size: 0.28rem;
  color: #666;
  // font-weight: bold;

}

.goods .iouc-wrap .left {
  font-size: 0.28rem;
  color: #666;
  // font-weight: bold;
}

.goods .fare-wrap .center,
.goods .iouc-wrap .center {
  padding-left: 0.24rem;
  box-sizing: border-box;
  font-size: 0.28rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.4rem;
}
.goods .fare-wrap .center {
  // width: calc(100% - 0.96rem);
  flex-grow: 1;
}
.goods .iouc-wrap .center {
  // width: calc(100% - 1.78rem);
  flex-grow: 1;
}
.goods .iouc-wrap .right {
  width: 0.48rem;
  height: 0.48rem;
  display: flex;
  align-items: center;
}

.goods .iouc-wrap .right img {
  width: 0.44rem;
  height: 0.44rem;
}
.tag-promise{
  // height: .68rem;
  .tag-container{
    // height: 0.68rem;
    // overflow: hidden;
    width: 6.3rem;
    // line-height: .68rem;
    padding-bottom: .12rem;
    img{
      width:100%;
      margin-top: 0.2rem;
    }
  }
}
.goods .tag-wrap {
  // height:.68rem;
  padding-left: 0.24rem;
  // background-color: rgba(238, 238, 238, 0.9);
  display: flex;
  justify-content: space-between;
}
.wrap-devider{
  width: 100%;
  height: .24rem;
  background-color: #f5f5f5 !important;
}
.tag-container{
  // height: 31px;
  overflow: hidden;
  width: 284px;
}

.goods .tag-wrap ul {
  display: flex;
  align-items: center;
  // padding-top: 0.24rem;
  // padding-bottom: 0.1rem;
  flex-wrap: wrap;
  // height:.68rem;
  margin-top: .24rem;
}

.goods .tag-wrap ul li {
  display: flex;
  align-items: center;
  font-size: 0.22rem;
  color: #999;
  margin-right: 0.15rem;
  position: relative;
  // transform: scale(0.936);
  transform-origin: left;
  margin-bottom: .12rem;
  .fangxin-icon{
    content: "";
    background-size: cover;
    height: 0.32rem;
    width: 0.32rem;
    display: inline-block;
    color: #999999;
    position: relative;
    transform: scale(0.9);
  }
  span{
    margin-left: 0.04rem;
    line-height: .32rem;
  }
}

.goods .tag-wrap ul li img {
  width: 0.22rem;
  margin-right: 0.1rem;
}
.store-info-wrap{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
  padding: 0.29rem 0.24rem;
  max-width: 100%;
  margin-top: .24rem;
  border-radius: .24rem;
  // min-height: 1rem;
  overflow: hidden;
  // position: relative;
  // width: 100%;
  .left{
    font-size: 0.28rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: bold;
    color: #666;
    line-height: 0.28rem;
    white-space: nowrap;
    padding-top: .04rem;
    img{
      width:48px;
      height:48px;
      border-radius: 8px;
    }
  }
  .center{
    flex-grow: 1;
    margin-left: 0.24rem;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    .top{
      position: relative;
      top:1px;
      font-size: 0.26rem;
      font-weight: bold;
      display: flex;
      color:#000000;
      .shop-icon{
        width:0.32rem;
        height:0.32rem;
        margin-right: 0.08rem;
      }
      .title{
        font-size: 0.28rem;
        line-height: 0.34rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: normal;
      }
    }
    .bottom{
      margin-top: 0.2rem;
      font-size: 0.24rem;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      word-break: break-all;
    }
  }
  .right{
    // align-self: center;
    height: 100%;
    align-self: stretch;
    // height grow
    // position: relative;
    // top: -10px;
  }
}
.guider-wrap {
  margin-top: 12px;
  border-radius: 12px;
  overflow: hidden;
  .wrap-title {
    padding-left: 14px;
    padding-top: 16px;
    font-size: 14px;
    font-weight: 500;
  }
}
.program-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 1rem;
  padding-left: 0.24rem;
  padding-right: 0.24rem;
  // border-top: 0.02rem solid #eee;
  .left {
  font-size: 0.28rem;
    display: flex;
    align-items: center;
    .tag {
      height: 0.36rem;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      // border: 0.01rem solid $themeSynMain;
      // font-size: 0.24rem;
      // color: $themeSynMain;
      margin-right: 0.24rem;
      color: #000;
      font-weight: bold;
    }
    .text {
      font-size: 0.22rem;
      color: rgba(51, 51, 51, 1);
      line-height: 0.4rem;
      position: relative;
      // border: 1px solid #2283E2;
      // border-radius: 0.06rem;
      padding: 0 0.14rem;
      color: #3B7EDD;

      img{
        position: absolute;
        top: 0;
        left: 0;
        // width: 100%;
        // height: .4rem;
      }
    }
    .text:before{
        content: "";
        position: absolute;
        border: 0.05rem solid #2283E2;
        border-radius: 0.3rem;
        width: 400%;
        height: 400%;
        transform-origin: 0 0;
        transform: scale(0.25, 0.25);
        box-sizing: border-box;
        top: 0;
        left: 0;
    }
  }
  img {
    width: 0.28rem;
    height: 0.28rem;
  }
}
.show-3d {
  border-top: 0.24rem solid #f2f2f2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 0.82rem;
  padding-left: 0.24rem;
  padding-right: 0.24rem;
  font-size: 0.24rem;
  color: rgba(153, 153, 153, 1);
  line-height: 0.34rem;
}
.show-3d img {
  width: 0.1rem;
  height: 0.16rem;
}
.description {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  .des-btn-box{
    height: calc(env(safe-area-inset-bottom,0) + 1.2rem);
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
    justify-content: center;
    align-items: center;
    display: flex;
    @include max-width;
    background-color: #fff; 
    border-top: 1px solid #E5E5E5;
    .des-btn {
      background-image: linear-gradient(90deg, #FFE1BC 0%, #FFC9A0 100%);
      height: .88rem;
      width: 6.86rem;
      text-align: center;
      color: #962F0B;
      font-size: .32rem;
      display: flex;
      font-weight: bold;
      justify-content: center;
      align-items: center;
      border-radius: 2rem;
    }
  }
  .content {
    background-image: linear-gradient(142deg, #FFEBCC 0%, #FFD3A0 49%, #FFE9D5 100%);
    border-radius: 12px 12px 0 0;
    padding-left: 0.16rem;
    padding-right: 0.16rem;
    padding-top: 14px;
    .des-devider{
      width: 100%;
      height: calc(env(safe-area-inset-bottom,0) + 1.2rem);
    }
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 0.8rem;
      svg {
        position: absolute;
        display: inline-block;
        width: 0.26rem;
        height: 0.26rem;
        top: 0.24rem;
      }
      .left{
       width: 100%;
       text-align: center;
       font-size: .32rem;
       color: #333333;
       display: flex;
       flex-direction: column;
       align-items: center;
       justify-content: center;

       img {
        height: 18px;
       }
       span {
        margin-top: 6px;
        font-size: 12px;
        color: #B8590F;
       }
      }
      .right {
        height: .8rem;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: .4rem;
        right: 10px;
        top: -8px;
      }
    }
    ul {
      height: 6.44rem;
      overflow-y: auto;
      background: #fff;
      margin-top: 12px;
      border-radius: 12px 12px 0 0;
      -webkit-overflow-scrolling: touch;
      padding: 20px; 
      padding-right: 16px;
      padding-left: 28px;
      list-style: none; /* 移除默认圆点 */
      &::-webkit-scrollbar {
        display: none;
      }
      li {
        position: relative;
        &::before {
          content: "";
          position: absolute;
          left: -10px;
          top: 13px;
          // transform: translateY(-50%);
          width: 16px; /* 图片宽度 */
          height: 16px; /* 图片高度 */
          background: url(#{$cdnImageUrl}/icon/new/service-item.png) no-repeat center/contain;
        }
        padding-top: 0.24rem;
        .tit {
          display: flex;
          align-items: center;
          padding-left: .2rem;
          justify-content: space-between;
          .img {
            width: 0.42rem;
            img {
              width: 0.26rem;
            }
          }
          .text {
          font-size: 15px;
          font-weight: bold;
          color: #111;
          position: relative;
          }
        }
        .desc {
           line-height: .38rem;
           color: #999999;
           font-size: 13px;
           margin-top: .14rem;
           padding-left: .2rem;
        }
      }
    }
  }
}
.commission-info{
  padding: 0.64rem 0.24rem;
  font-size: 0.28rem;
  line-height: 0.4rem;
  .bounty{
    margin-top: 0.4rem;
  }
}
.iouc-subtitle {
  padding:0.24rem;
  font-size: 0.24rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333;
  line-height: 0.24rem;
}
.iouc-table {
  padding: 0 0.24rem;
  margin-bottom: 0.52rem;
  max-height: 5.5rem;
  overflow-x: hidden;
  .iouc-cell {
    padding: 0.18rem 0;
    .each-price {
      padding-bottom: 0.24rem;
      font-size: 0.28rem;
      color: #333333;
      letter-spacing: -0.01rem;
    }
    .fee{
      pre{
        font-size: 0.22rem;
        color: #666;
        letter-spacing: -0.01rem;
      }
    }
  }
}
.iouc-buttom {
  width: 6.85rem;
  // bottom: 0.24rem;
  height: 0.88rem;
  line-height: 0.88rem;
  font-size: 0.32rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fff;
  background: #2283e2;
  text-align: center;
  margin: 0 auto 0.24rem;
  border-radius: 2rem;
}
.goods .price-wrap .normal{
  padding-top: .3rem;
  // display: flex;
  // flex-direction: column;
}
.goods .price-wrap .coupon-label-msg {
  color: #ED2856;
  font-size: 0.22rem;
  padding: 0.1rem 0;
}
.location-icon{
  margin-right: 0.08rem;
  width: 12px;
  height: 13px;
}
.addr-container{

  .addr-header{
    height: 0.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: .32rem;
    color: #333;
    position: relative;
    img{
      width: .24rem;
      height: .24rem;
      position: absolute;
      right: 0.24rem;
      top: calc(50% - 6px);
    }
  }
}
.info-container :deep(.van-popup) {
  z-index: 2560 !important;
}
.newDescribe{
  padding-top: 0.14rem;
  font-size: 12px;
  color: #666666;
  line-height: 18px;
  span {
    &::after {
      content: ' ';
      width: 1px;
      display: inline-block;
      height: 12px;
      background-color: #666;
      margin-left: 4px;
      margin-right: 4px; 
      position: relative;
      top: 2px;
      transform: scaleX(0.5);
      transform-origin: center; /* 缩放的基准点 */
    }
  }
  span:last-child::after {
    display: none;
  }
}
// .goods-tag{
//   height: 0.4rem;
//   overflow: hidden;
//   padding: 0.24rem 0 0.16rem 0.24rem;
//   margin:0 0.01rem 0 0.01rem;
//   transform: scale(0.75);
//   transform-origin: left;
//   overflow: hidden;
//   width: 6.73rem;
//   ul{
//     display: flex;
//     flex-wrap: wrap;
//     li{
//       margin:0 0 0.25rem 0.08rem;
//       font-size: 0.214rem;
//       img{
//         height:0.32rem;
//       }
//     }
//     li:first-child{
//       margin-left:0;
//     }
//   }
//   :deep(.van-tag) {
//     padding:0.02rem 0.05rem 0.02rem 0.04rem;
//     border-radius: 0.06rem;
//   }
// }
.goods-tag{
  height: 0.4rem;
  line-height: 0.4rem;
  overflow: hidden;
  /* padding: 0.1rem 0.01rem 0 0; */
  margin-left: 0.24rem;
  // margin:  0 0.01rem;
  transform: scale(0.88);
  transform-origin: left;
  padding-top: .06rem;
  // width: 9rem;
  ul{
    display: flex;
    flex-wrap: wrap;
    height: 0.57rem;
    overflow: hidden;
    align-items: center;
    li{
      margin:0 0 0.25rem 0.08rem;
      display: flex;
      align-items: center;
      padding-top: 0.05rem;
      img{
        height:0.334rem;
      }
      span{
        vertical-align:top;
        display: inline-block;
        padding: 0.027rem 0.1rem;
        line-height: 1.43;
        height:0.28rem;
        line-height: .28rem;
        display: flex;
        align-items: center;
      }
    }
    li:first-child{
      margin-left:0;
    }
    :deep(.van-tag) {
      border-radius: 0.08rem;
      font-size: 0.24rem;
    }
    :deep(.van-tag::after) {
      border-radius: 0.16rem;
      font-size: 0.24rem;
    }
  }
}

.info-container :deep(.van-popup--bottom) {
  border-radius: 12px 12px 0 0;
}
.close-icon__bill :deep([class*=van-hairline]::after) {
  border: none;
  :deep(.van-tag) {
    padding:0.02rem 0.05rem 0.02rem 0.04rem;
    border-radius: 0.06rem;
  }
}

.goods .price-wrap .current-price .current span.range-after{
  font-size: 0.24rem;
  line-height: 0.32rem;
  position: relative;
  top: -1px;
}
.price-wrap-pre{
  padding:.2rem .32rem;
}
.price-wrap-pre-content{
  height: 24px;
  background: rgba($color: $themeSynRed, $alpha: 0.06);
  border-radius: 0.12rem;
  display: flex;
  width:100%;
}
.price-wrap-pre-tag{
  width:1.2rem;
  height:100%;
  line-height: 24px;
  text-align: center;
  font-size: 11px;
  color: $themeSynRed;
  background: rgba($color: $themeSynRed, $alpha: 0.15);
  border-radius: .12rem 0 0 .12rem;
}
.price-wrap-pre-text{
  font-weight: 400;
  padding-left:.2rem;
  color: $themeSynRed;
  font-size:.24rem;
  display: flex;
  align-items: center;
  img{
    width:.3rem;
  }
}

.detail-title{
  .title{
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    .collect-container{
      padding-right: .04rem;
      padding-left: .3rem;
      width: .6rem;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      .collect-icon{
        display: inline-block;
        width: .38rem;
        height: .36rem;
        margin-bottom: .04rem;
      }
      .active{
        color: #F4CB4A;
      }
      .collect-text{
        font-size: .4rem;
        color: #333333;
        width: 1.2rem;
        transform: scale(0.5);
        transform-origin: top center;
        text-align: center;
        white-space: nowrap;
      }
    }
  }
}
.oldForNew{
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000000;
  padding: .24rem;
  .left{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .label{
      font-size: .28rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      margin-right: .32rem;
    }
    .info{
      font-size: .24rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      display: flex;
      align-items: center;
      .oldForNew-icon{
        width: 1.04rem;
        height: 0.22rem;
        display: inline-block;
        background: url('https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/goodsDetail/good-old-for-new-syn.png') center center no-repeat;
        background-size: cover;
        margin-right: .12rem;
      }
    }
  }
}
.internal-logo{
  width: 1.02rem;
  height: .24rem;
  // background: url('https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/internalChannel/internal-tag.png') center center no-repeat;
  background: url('https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/internalChannel/internal-tag-discount.png') center center no-repeat;
  background-size: cover;
  margin-left: .16rem;
}
.deposit-container{
  margin-top: .14rem;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: .3rem;
  padding-bottom: .44rem;
  background-image: linear-gradient(270deg, #F9F4FF 0%, #F7F2FF 100%);
  border-radius: 8px;
  width: 351px;
  box-sizing: border-box;
  margin-left: -4px;
  // margin-bottom: -0.24rem;
  .final-row{
    // margin-top: .3rem;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    .left{
      line-height: 17px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: .24rem;
      color: #5921FF;
      margin-right: .58rem;
      margin-top: .18rem;
    }
    .right{
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      .final-price{
        line-height: .52rem;
        // font-family: DINAlternate-Bold;
        font-family: PingFangSC-Medium;
        font-weight: Bold;
        font-size: .44rem;
        color: #5921FF;
        letter-spacing: 0;
        .yuan,.price-float{
          font-size: .28rem;
        }
        .yuan{
          margin-right: .08rem;
        }
      }
      .time-area{
        line-height: .34rem;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: .24rem;
        color: #000000;
      }
    }
  }
  .process-row{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: .28rem;
    .left{
      line-height: 17px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: .24rem;
      color: #5921FF;
      margin-right: .58rem;
      display: flex;
      align-items: center;
    }
    .right{
      line-height: .34rem;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: .24rem;
      color: #000000;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .process-devider{
        width: .72rem;
        height: .02rem;
        opacity: 0.2;
        background: #222222;
        margin: 0 .16rem;
      }
    }
  }
}
.goods .inner-bouble{
    z-index: 2;
    position: absolute;
    top: 0rem;
    width: 3.62rem;
    height: 1.26rem;
    background: #fff;
    border-radius: .16rem;
    background: $themeSynMain;
    padding: 0.12rem 0.24rem 0.16rem 0.24rem;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    .bouble-top{
      display: block;
      position: absolute;
      top: -0.12rem;
      width: 0.3rem;
      height: 0.3rem;
      transform: rotate(45deg);
      background: $themeSynMain;
      border-radius: 0.07rem;
    }
    .bouble-content {
      width: 100%;
      height: 100%;
      line-height: 0.4rem;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      font-size: .24rem;
      color: #fff;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      z-index: 2;
    }
    .confirm-box {
      height: auto;
      position: relative;
      z-index: 2;
      .confirm-btn {
        position: absolute;
        width: .96rem;
        height: .4rem;
        font-weight: 400;
        font-size: 0.24rem;
        font-family: PingFangSC-Regular;
        background: #FFFFFF;
        border-radius: .08rem;
        color: $themeSynMain;
        display: flex;
        align-items: center;
        justify-content: center;
        bottom: 0rem;
        right: 0rem;
      }
    }
  }

</style>

